<template>
  <div class="hm-send-container">
    <el-card>
      <el-form
        :model="ruleForm"
        :rules="rules"
        label-width="140px"
        ref="ruleForm"
      >
        <el-form-item label="发放名称：" prop="name" :error="couponNameError">
          <el-input
            size="small"
            clearable
            :disabled="isPreview && (($route.query.type && $route.query.type!=='edit') || !$route.query.type)"
            v-model.trim="ruleForm.name"
            @blur="checkCouponNameValid"
          ></el-input>
        </el-form-item>
        <el-form-item label="副标题：">
          <el-input
            size="small"
            clearable
            placeholder="客户不可见,仅为后台备注"
            v-model.trim="remark"
          ></el-input>
        </el-form-item>

        <el-form-item label="发放类型：">
          <div class="hm-form-container">
            <el-radio-group
              size="small"
              :disabled="isPreview || isEdit"
              v-model="sendWayType"
              @change="sendWayTypeChange"
            >
              <el-radio-button :label="0">自动发放</el-radio-button>
              <el-radio-button :label="1">手动发放</el-radio-button>
              <el-radio-button :label="5">自助领券</el-radio-button>
              <!--              <el-radio-button :label="2">自助领券</el-radio-button>-->
              <!-- <el-radio-button :label="3">兑换码领取</el-radio-button> -->
              <el-radio-button :label="4">活动发放</el-radio-button>
            </el-radio-group>
            <div>
              <span
                class="title"
                v-show="sendWayType === 0 || sendWayType === 4"
                >发放限制：</span
              >
              <div class="no-lineHeight">
                <div>
                  <el-radio-group
                    style="line-height: 30px"
                    @change="eventChange"
                    size="small"
                    :disabled="isPreview || isEdit"
                    v-model="event"
                  >
                    <el-radio label="registe" v-show="sendWayType === 0"
                      >开卡绑定</el-radio
                    >
                    <el-radio label="follow" v-show="sendWayType === 0"
                      >关注公众号</el-radio
                    >
                    <el-radio label="levelup" v-show="sendWayType === 0"
                      >升级plus会员</el-radio
                    >
                    <el-radio label="orderOffline" v-show="sendWayType === 0"
                      >门店交易</el-radio
                    >
                    <el-radio label="orderOnline" v-show="sendWayType === 0"
                      >线上交易</el-radio
                    >
                    <!-- <el-radio label="recharge" v-show="sendWayType === 0">充值</el-radio> -->
                    <!-- <el-radio label="PasswordRedEnvelope" v-show="sendWayType === 0">口令红包</el-radio> -->
                    <!-- <el-radio label="bigturntable" v-show="sendWayType === 0">大转盘</el-radio> -->
                    <!-- <el-radio label="repository" v-show="sendWayType === 0">母婴知识库</el-radio> -->
                    <!-- <el-radio label="wyethNewCustomer" v-show="sendWayType === 0">惠氏新客</el-radio> -->
                    <el-radio label="share" v-show="sendWayType === 0"
                      >预约活动-分享发券</el-radio
                    >
                    <el-radio label="buy" v-show="sendWayType === 0"
                      >预约活动-购买发券</el-radio
                    >
                    <el-radio label="charge" v-show="sendWayType === 0"
                      >预约活动-核销发券</el-radio
                    >
                    <el-radio
                      label="recommendedPurchase"
                      v-show="sendWayType === 0"
                      >推荐购买发券</el-radio
                    >
                    <el-radio label="luckyDraw" v-show="sendWayType === 0"
                      >抽奖发券</el-radio
                    >

                    <!-- <el-radio label="marketing" v-show="sendWayType === 0">营销审核发券</el-radio> -->
                    <!-- <el-radio
                      label="exchangeByPoint"
                      v-show="sendWayType === 4"
                      style="margin-left: 0"
                    >积分兑换</el-radio>
                    <el-radio label="carnival" v-show="sendWayType === 4">满额领券</el-radio>-->
                    <el-radio label="activity" v-show="sendWayType === 4"
                      >活动发券</el-radio
                    >
                    <el-radio label="wxCardSend" v-show="sendWayType === 0"
                      >微信卡包</el-radio
                    >
                    <el-radio
                      label="frisonNu"
                      v-show="sendWayType === 0 && isFriso"
                      >美素新客</el-radio
                    >
                  </el-radio-group>
                </div>
              </div>
            </div>

            <div v-show="event === 'registe'">
              <span class="title">是否绑定导购：</span>
              <div>
                <el-checkbox
                  v-model="bindGuider"
                  label="绑定导购"
                  :disabled="isPreview || isEdit"
                ></el-checkbox>
              </div>
              <div v-if="bindGuider">
                <hm-guider-transfer
                  ref="bingGuiderTransfer"
                ></hm-guider-transfer>
              </div>
            </div>


            
            <div v-show="event === 'orderOffline'">
              <shop-picker
                :available-shops="shopList.records || []"
                :selected-shops.sync="selectedShops"
                :readonly="isPreview || isEdit"
                @change="handleShopPickerChange"
              />
            </div>



          </div>
        </el-form-item>
        <el-form-item
          label="发放对象："
          prop="isPlus"
          v-if="sendWayType == '0' && event == 'orderOnline'"
        >
          <el-radio-group
            size="small"
            :disabled="isPreview || isEdit"
            v-model="ruleForm.isPlus"
          >
            <el-radio :label="1">全部会员</el-radio>
            <el-radio :label="0">plus会员</el-radio>
            <el-radio :label="2">非plus会员</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="宝宝生日："
          v-if="event === 'registe' && physiologicalBabyList.length"
        >
          <el-checkbox-group v-model="ageRuleModelList">
            <el-checkbox
              :label="v.id"
              v-for="(v, i) in physiologicalBabyList"
              :key="i"
              >{{ v.rangeName }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          label="孕产期："
          v-if="event === 'registe' && physiologicalPregnantList.length"
        >
          <el-checkbox-group v-model="ageRuleModelList">
            <el-checkbox
              :label="v.id"
              v-for="(v, i) in physiologicalPregnantList"
              :key="i"
              >{{ v.rangeName }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          label="领券形式："
          v-show="sendWayType === 2 || sendWayType === 5"
        >
          <el-radio-group
            size="small"
            :disabled="isPreview || isEdit"
            v-model="isActivity"
            @change="isActivityChange"
          >
            <el-radio :label="0">个人中心领券</el-radio>
            <el-radio :label="1">扫码领券</el-radio>
            <el-radio :label="2">PLUS会员领券</el-radio>
            <el-radio :label="3">导购中心领券</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="单次领取限制："
          :key="Math.random()"
          v-if="
            (sendWayType === 2 || sendWayType === 5) &&
            (isActivity === 0 || isActivity === 1)
          "
          prop="sendCountLimit"
        >
          <el-radio-group
            size="small"
            :disabled="isPreview || isEdit"
            v-model="ruleForm.sendCountLimit"
          >
            <el-radio :label="0" :disabled="isActivity === 0"
              >限制使用后领券</el-radio
            >
            <el-radio :label="1">不限制</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="发券方式："
          prop="distributionType"
          v-if="sendWayType === 0 && event === 'recommendedPurchase'"
        >
          <el-radio-group
            size="small"
            :disabled="isPreview || isEdit"
            v-model="ruleForm.distributionType"
          >
            <el-radio label="references">仅推荐人获券</el-radio>
            <el-radio label="referencesAndBuyers"
              >推荐人和购买者都获券</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="推荐人身份限制："
          prop="identityType"
          v-if="sendWayType === 0 && event === 'recommendedPurchase'"
        >
          <el-select
            size="small"
            placeholder="选择分类方式"
            v-model="ruleForm.identityType"
            filterable
            @change="identityTypeChange"
            class="mr10"
          >
            <el-option label="全部类型推荐人" value="all"></el-option>
            <el-option label="会员卡类型" value="cardType"></el-option>
            <el-option label="会员群组" value="group"></el-option>
          </el-select>
          <el-select
            clearable
            v-if="ruleForm.identityType === 'cardType'"
            class="mr10"
            size="small"
            v-model="ruleForm.identityValue"
            placeholder="请选择卡类型"
            filterable
            multiple
          >
            <el-option
              :label="v.typeName"
              :value="v.cardTypeId"
              :key="i"
              v-for="(v, i) in cardTypeList"
            ></el-option>
          </el-select>
          <el-select
            v-if="ruleForm.identityType === 'group'"
            clearable
            multiple
            filterable
            size="small"
            v-model="ruleForm.identityValue"
            placeholder="请选择会员群组"
          >
            <el-option
              :label="v.groupAppellation"
              :value="v.groupId"
              v-for="(v, i) in memberGroupList"
              :key="i"
            ></el-option>
          </el-select>
          <span class="form-item-tip"
            >表示只有这类会员分享才可以触发分享购买发券机制。
          </span>
        </el-form-item>
        <el-form-item
          label="发券计数："
          prop="counted"
          v-if="sendWayType === 0 && event === 'recommendedPurchase'"
        >
          <el-radio-group
            size="small"
            :disabled="isPreview || isEdit"
            v-model="ruleForm.counted"
          >
            <el-radio label="goods">按照商品数量计算</el-radio>
            <el-radio label="order">按照订单计算</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="券包领取人数："
          prop="sendNum"
          v-if="
            (sendWayType !== 1 &&
              sendWayType !== 4 &&
              event !== 'luckyDraw' &&
              event !== 'wxCardSend' &&
              event !== 'frisonNu') ||
            (sendWayType === 4 && event === 'activity')
          "
        >
          <el-checkbox
            v-model="noGetCouponLimit"
            label="不限制领取人数"
            ref="limitCheckBox"
            v-show="sendWayType === 0"
            :disabled="isPreview || isEdit"
            class="mr10"
          ></el-checkbox>
          <div>
            <el-input
              size="small"
              @mousewheel.prevent.native
              :style="{ marginTop: sendWayType === 0 && '.5rem' }"
              :class="{ isDisabled: isPreview }"
              type="number"
              placeholder="输入券包领取人数限制"
              :disabled="isPreview || isEdit"
              v-model.trim="ruleForm.sendNum"
              min="1"
              max="1000"
              v-show="
                (sendWayType === 0 && !noGetCouponLimit) || sendWayType !== 0
              "
            />
            <span
              class="form-tip"
              v-show="
                (sendWayType === 0 && !noGetCouponLimit) || sendWayType !== 0
              "
              >(数量区间1-10000)</span
            >
          </div>
        </el-form-item>
        <!-- 交易发放 -->
        <div
          v-show="
            (sendWayType === 0 &&
              (event === 'orderOffline' ||
                event === 'orderOnline' ||
                event === 'recharge')) ||
            (sendWayType === 4 && event === 'carnival')
          "
        >
          <div v-show="event === 'orderOffline' || event === 'orderOnline'">
            <el-form-item label="按商品件数发放：">
              <el-checkbox
                v-model="sendByGoodsCount"
                label="按商品件数发放"
                ref="limitCheckBox"
                :disabled="isPreview || isEdit"
                @change="sendByGoodsCountChange"
              ></el-checkbox>
              <span class="form-item-tip"
                >（选择按商品件数发放后则必须设置发放商品限制）</span
              >
            </el-form-item>
            <el-form-item label="叠加类型：" prop="overlayType">
              <el-radio-group v-model="ruleForm.overlayType" size="small" :disabled="isPreview || isEdit">
                <el-radio label="no">不叠加</el-radio>
                <el-radio label="ladder">阶梯叠加</el-radio>
                <el-radio label="cycle">循环叠加</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div v-show="sendByGoodsCount">
            <el-form-item label="最小商品数量限制" prop="goodsNumMin">
              <el-input
                size="small"
                :class="{ isDisabled: isPreview }"
                @mousewheel.prevent.native
                type="number"
                placeholder="请输入数量"
                :disabled="isPreview&& (($route.query.type && $route.query.type!=='edit') || !$route.query.type)"
                v-model.trim="ruleForm.goodsNumMin"
                @change="goodsNumMinChange"
              ></el-input
              >个
            </el-form-item>
            <el-form-item label="最大商品数量限制" prop="goodsNumMax">
              <el-input
                size="small"
                :class="{ isDisabled: isPreview }"
                @mousewheel.prevent.native
                type="number"
                placeholder="请输入数量"
                :disabled="isPreview&& (($route.query.type && $route.query.type!=='edit') || !$route.query.type)"
                @change="goodsNumMinChange"
                v-model.trim="ruleForm.goodsNumMax"
              ></el-input
              >个
            </el-form-item>
          </div>
          <div v-show="!sendByGoodsCount || event === 'carnival'">
            <el-form-item
              :label="
                event === 'orderOffline' ||
                event === 'orderOnline' ||
                event === 'carnival'
                  ? '最小订单金额：'
                  : '最小充值金额：'
              "
              prop="amountMin"
            >
              <el-input
                size="small"
                :class="{ isDisabled: isPreview }"
                @mousewheel.prevent.native
                type="number"
                placeholder="请输入金额"
                :disabled="isPreview || isEdit"
                @change="goodsNumMinChange"
                v-model.trim="ruleForm.amountMin"
              ></el-input
              >元
            </el-form-item>
            <el-form-item
              :label="
                event === 'orderOffline' ||
                event === 'orderOnline' ||
                event === 'carnival'
                  ? '订单金额上限：'
                  : '充值金额上限：'
              "
              prop="amountMax"
            >
              <el-input
                size="small"
                :class="{ isDisabled: isPreview }"
                @mousewheel.prevent.native
                type="number"
                placeholder="请输入金额"
                @change="goodsNumMinChange"
                :disabled="isPreview || isEdit"
                v-model.trim="ruleForm.amountMax"
              ></el-input
              >元
            </el-form-item>
          </div>
          <div v-show="event === 'orderOffline' || event === 'orderOnline'">
            <el-form-item
              label="叠加规则："
              prop="overlayRuleModelList"
              v-if="ruleForm.overlayType === 'ladder'"
            >
              <div class="flex item-center way-item">
                买满<el-input
                  size="small"
                  v-model="sendLimitNew"
                  @input="filterGt0OrFixed0('sendLimitNew')"
                  type="number"
                ></el-input
                >{{ sendByGoodsCount ? "件" : "元" }}，发放以下券包
                <el-input
                  size="small"
                  v-model="sendNumNew"
                  @input="filterGt0OrFixed0('sendNumNew')"
                  type="number"
                ></el-input
                >组
                <div class="add-wrapper">
                  <span
                    class="hmicon icon-hao pointer"
                    @click="
                      addItem('overlayRuleModelList', sendLimitNew, sendNumNew)
                    "
                  ></span>
                </div>
              </div>
              <div
                class="flex item-center way-item"
                v-for="(v, i) in ruleForm.overlayRuleModelList"
                :key="i"
              >
                买满
                <div style="width: 40px" class="text-center primary">
                  {{ v.sendLimit }}
                </div>
                <!-- <el-input
                  size="small"
                  :readonly="true"
                  v-model="v.sendLimit"
                  type="number"
                ></el-input> -->
                {{ sendByGoodsCount ? "件" : "元" }}，发放以下券包
                <div style="width: 40px" class="text-center primary">
                  {{ v.sendNum }}
                </div>
                <!-- <el-input
                  size="small"
                  :readonly="true"
                  v-model="v.sendNum"
                  type="number"
                ></el-input
                > -->
                组
                <div class="minus-wrapper">
                  <span
                    class="hmicon icon-jianhao pointer"
                    @click="deleteItem('overlayRuleModelList', i)"
                  ></span>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              label="叠加规则："
              prop="sendLimitNew"
              v-else-if="ruleForm.overlayType === 'cycle'"
            >
              <div class="flex item-center way-item">
                买满<el-input
                  size="small"
                  v-model="sendLimitNew"
                  @input="filterGt0OrFixed0('sendLimitNew')"
                  type="number"
                ></el-input
                >{{ sendByGoodsCount ? "件" : "元" }}，发放以下券包
                <el-input
                  size="small"
                  v-model="sendNumNew"
                  @input="filterGt0OrFixed0('sendNumNew')"
                  type="number"
                ></el-input
                >组，发放券包最多循环<el-input
                  size="small"
                  v-model="maxCycleTimes"
                  @input="filterGt0OrFixed0('maxCycleTimes')"
                  type="number"
                ></el-input
                >次，超出部分不发放。
              </div>
            </el-form-item>
          </div>
        </div>
        <el-form-item
          label="券代码："
          class="is-required"
          v-if="sendWayType !== 1 && event == 'frisonNu'"
        >
          <el-select
            size="small"
            filterable
            clearable
            placeholder="选择券代码"
            :disabled="isPreview || isEdit"
            v-model="ruleForm.couponCode"
            class="width-auto mr10"
          >
            <el-option
              v-for="item in couponCode"
              :key="item.itemValue"
              :label="item.itemText"
              :value="item.itemValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="定时发放："
          class="is-required"
          v-if="sendWayType !== 1 && event !== 'luckyDraw'"
        >
          <hm-date-select
            :isPreview="isPreview"
            title="发放"
            ref="hmDateSelect"
            :multipleTime="isMultipleTime"
          ></hm-date-select>
        </el-form-item>
        <div>
          <!-- 开卡绑定 关注公众号 升级plus会员 -->
          <div
            class="card-item"
            v-show="
              event === 'orderOffline' ||
              event === 'orderOnline' ||
              (event === 'recommendedPurchase' && ruleForm.counted === 'goods')
            "
          >
            <el-form-item label="可选商品" class="is-required">
              <span class="form-item-tip">
                (注：若不设置商品规则，则默认
                <strong>购买满足最小订单金额的任意商品即会发放优惠券</strong>)
              </span>
              <div class="hm-form-container">
                <div class="flex flex-between">
                  <hm-micro-shop-transfer
                    ref="goodsTransfer"
                    showUseable
                    showAttribute
                    showBarcode
                    @checkGoods="checkGoods"
                    :leftOption="leftGoodsRules"
                  ></hm-micro-shop-transfer>
                </div>
                <div v-show="sendByGoodsCount && !isCheckGoods" class="error">
                  请选择商品限制
                </div>
              </div>
            </el-form-item>
          </div>
          <div class="card-item" v-show="sendWayType === 1">
            <el-form-item class="is-required" label="发放对象：">
              <div class="hm-form-container">
                <el-radio-group
                  size="small"
                  :disabled="isPreview || isEdit"
                  v-model="sendTarget"
                  class="card-item"
                >
                  <el-radio-button :label="1">发放用户</el-radio-button>
                  <el-radio-button :label="2">发放导购</el-radio-button>
                  <!-- <el-radio-button :label="3">发放门店</el-radio-button> -->
                </el-radio-group>
                <div class="card-item">
                  <div class="transfer-panel">
                    <div :class="sendLimit === 1 ? 'radio-group-wrapper' : ''">
                      <el-radio-group
                        size="small"
                        :disabled="isPreview || isEdit"
                        v-model="sendLimit"
                        style="margin-right: 2rem"
                        v-show="sendTarget === 1"
                      >
                        <el-radio :label="0">发放所有</el-radio>
                        <el-radio :label="1">指定用户</el-radio>
                        <el-radio :label="4">导入用户</el-radio>
                        <!-- <el-radio :label="2" v-show="sendTarget === 2">指定导购</el-radio>
                        <el-radio :label="3" v-show="sendTarget === 3">指定门店</el-radio>-->
                      </el-radio-group>
                    </div>
                    <!-- 指定用户显示 -->
                    <el-cascader
                      clearable
                      v-if="sendTarget !== 1"
                      style="margin-right: 10px"
                      :disabled="isPreview || isEdit"
                      ref="cascader"
                      v-model="selectedStore"
                      :props="props"
                      :show-all-levels="false"
                      size="small"
                      placeholder="请选择机构"
                    ></el-cascader>
                    <el-input
                      size="small"
                      clearable
                      class="mr10"
                      placeholder="搜索用户手机号/会员卡号"
                      v-model.trim="keywords"
                      v-show="sendTarget === 1 && sendLimit === 1"
                      style="width: 250px"
                    ></el-input>
                    <el-button
                      size="small"
                      :disabled="
                        isPreview ||
                        (sendTarget === 1 && sendLimit === 1 && keywords === '')
                      "
                      type="primary"
                      @click="searchByPhoneOrCardId"
                      v-show="sendTarget === 1 && sendLimit === 1"
                      >查询</el-button
                    >
                    <!-- <el-button
                      size="small"
                      @click="assignCustomer"
                      type="text"
                      v-show="sendTarget === 1 && sendLimit === 1"
                    >去筛选用户</el-button>-->
                    <!-- 指定导购显示 -->
                    <el-input
                      size="small"
                      class="mr10"
                      clearable
                      :placeholder="targetPlaceholder"
                      v-model.trim="targetName"
                      v-show="sendTarget !== 1"
                    ></el-input>
                    <el-button
                      size="small"
                      :disabled="isPreview || isEdit"
                      type="primary"
                      @click="searchTarget"
                      v-show="sendTarget !== 1"
                      >查询</el-button
                    >
                    <div v-show="sendTarget !== 1">
                      <el-button size="small" @click="outputGuider"
                        >导出模板</el-button
                      >
                      <el-button
                        type="primary"
                        class="open-file"
                        size="small"
                        :disabled="isPreview || isEdit"
                      >
                        导入数据
                        <input
                          :disabled="isPreview || isEdit"
                          type="file"
                          @change="importfGuider"
                          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        />
                      </el-button>
                      <el-button
                        size="small"
                        type="primary"
                        v-if="errInputResultGuider.length"
                        @click="hasInValidGuider = true"
                        >查看导入失败会员</el-button
                      >
                    </div>
                  </div>
                  <!-- 指定用户才显示 -->
                  <div
                    class="transfer"
                    v-show="sendTarget === 1 && sendLimit === 1"
                  >
                    <div class="flex transfer-header flex-center">
                      <div class="select flex-2 text-center">
                        <span class="leftName">给下列用户发放优惠券</span>
                      </div>
                    </div>
                    <div class="transfer-body">
                      <el-table
                        ref="userTable"
                        :data="customer"
                        style="width: 100%"
                        empty-text="还未指定用户"
                        @selection-change="getChecked"
                      >
                        <el-table-column
                          type="selection"
                          width="30"
                        ></el-table-column>
                        <el-table-column
                          header-align="center"
                          align="center"
                          prop="realName"
                          label="用户名"
                        ></el-table-column>
                        <!-- <el-table-column
                          header-align="center"
                          align="center"
                          prop="memberName"
                          label="商城昵称"
                        ></el-table-column>
                        -->
                        <el-table-column
                          header-align="center"
                          align="center"
                          prop="mobilePhone"
                          label="手机号"
                        ></el-table-column>
                        <el-table-column
                            header-align="center"
                            align="center"
                            prop="cardNo"
                            label="会员卡号"
                        ></el-table-column>
                      </el-table>
                    </div>
                  </div>
                  <div
                    class="input-data"
                    v-show="sendTarget === 1 && sendLimit === 4"
                  >
                    <div class="flex flex-between input-panel item-center">
                      <div>选择分配的会员</div>
                      <div>
                        <el-button size="small" @click="output"
                          >导出模板</el-button
                        >
                        <el-button
                          type="primary"
                          class="open-file"
                          size="small"
                          :disabled="isPreview || isEdit"
                        >
                          导入数据
                          <input
                            :disabled="isPreview || isEdit"
                            type="file"
                            @change="importf"
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          />
                        </el-button>
                        <el-button
                          size="small"
                          type="primary"
                          v-if="errInputResult.length"
                          @click="hasInValidPhone = true"
                          >查看导入失败会员</el-button
                        >
                      </div>
                    </div>
                    <div class="scroll-wrapper">
                      <el-table :data="inputData" border class="small-table">
                        <el-table-column
                          prop="name"
                          label="用户名"
                        ></el-table-column>
                        <el-table-column
                          prop="mobile"
                          label="手机号"
                        ></el-table-column>
                      </el-table>
                      <div class="error" v-show="inputData.length <= 0">
                        请导入分配的会员
                      </div>
                    </div>
                  </div>
                  <hm-transfer
                    v-show="sendTarget === 2"
                    :isPreview="isPreview"
                    transferMode="sendTarget"
                    background="danger"
                    leftName="所有导购"
                    rightName="给下列导购发放优惠券"
                    :leftOption="leftSendTargetList"
                    ref="guideTransfer"
                    @hasCheckedGuider="hasCheckedGuider"
                    :isEnable="false"
                  ></hm-transfer>
                </div>

                <div
                  class="error"
                  v-show="
                    ((sendTarget === 1 &&
                      sendLimit === 1 &&
                      multipleSelection.length <= 0) ||
                      (sendTarget === 2 &&
                        $refs.guideTransfer &&
                        $refs.guideTransfer.rightChecked.length <= 0)) &&
                    sendWayType === 1
                  "
                >
                  请选择发放对象
                </div>
              </div>
            </el-form-item>
          </div>
          <el-form-item class="is-required" label="添加优惠券规则">
            <span class="form-item-tip">选择数量应小于每人限领张数</span>
            <div class="hm-form-container">
              <div class="transfer-panel item-center flex flex-wrap">
                <el-select
                  size="small"
                  clearable
                  filterable
                  placeholder="使用平台"
                  v-model="sysTag"
                  class="mr10"
                >
                  <el-option label="禾苗主系统" :value="0"></el-option>
                  <el-option label="服务系统" :value="1"></el-option>
                </el-select>
                <el-select
                  size="small"
                  clearable
                  placeholder="选择券类型"
                  :disabled="isPreview || iswx"
                  v-model="couponType"
                  class="mr10"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-select
                  size="small"
                  clearable
                  placeholder="选择使用对象"
                  :disabled="isPreview || isEdit"
                  v-model="useTarget"
                  class="mr10"
                >
                  <el-option label="PLUS会员" :value="0"></el-option>
                  <el-option label="全部会员" :value="1"></el-option>
                </el-select>
                <el-select
                  size="small"
                  clearable
                  placeholder="选择标签"
                  v-model="label"
                  style="width: 150px"
                  class="mr10"
                >
                  <el-option
                    v-for="item in tabList"
                    :key="item.couponLabelId"
                    :label="item.labelName"
                    :value="item.couponLabelId"
                  ></el-option>
                </el-select>
                <el-date-picker
                  class="mr10"
                  size="small"
                  value-format="yyyy-MM-dd"
                  :disabled="isPreview || isEdit"
                  v-model="ruleValidDate"
                  placeholder="选择时间"
                  type="daterange"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
                <el-input
                  class="mr10"
                  size="small"
                  clearable
                  placeholder="输入券名"
                  :disabled="isPreview || isEdit"
                  v-model.trim="couponName"
                ></el-input>
                <el-button
                  size="small"
                  :disabled="isPreview || isEdit"
                  @click="resetRules"
                  class="mr10"
                  style="height: 100%"
                  >重置</el-button
                >
                <el-button
                  size="small"
                  :disabled="isPreview || isEdit"
                  type="primary"
                  style="margin-left: 0; height: 100%"
                  @click="queryRules"
                  >搜索</el-button
                >
              </div>
              <hm-transfer
                ref="ruleTransfer"
                :onlySelectOne="sendWayType === 4"
                :isPreview="isPreview"
                background="danger"
                leftName="可选规则"
                rightName="已选择的规则"
                :eventType="event"
                :leftOption="leftRules"
                transferMode="selectRule"
              ></hm-transfer>
            </div>
          </el-form-item>
          <!-- <el-form-item
            label="添加绑定导购："
            v-if="bindGuider"
            class="is-required"
          >
            <div class="hm-form-container">
              <div class="transfer-panel flex">
                <el-cascader
                  clearable
                  style="marginRight:10px"
                  :disabled="isPreview || isEdit"
                  ref="cascader"
                  v-model="selectedStore"
                  :props="props"
                  :show-all-levels="false"
                  size="small"
                  placeholder="请选择机构"
                ></el-cascader>

                <el-button
                  size="small"
                  :disabled="isPreview || isEdit"
                  @click="resetBindGuider"
                  class="mr10 hmicon icon-zhongzhi"
                ></el-button>
                <el-button
                  size="small"
                  :disabled="!selectedStore.length || isPreview"
                  type="primary"
                  class="hmicon icon-search"
                  style="margin-left: 0"
                  @click="toQueryBindGuider"
                ></el-button>
              </div>
              <hm-transfer
                ref="bingGuiderTransfer"
                :isPreview="isPreview"
                background="danger"
                leftName="所有导购"
                rightName="绑定下列导购"
                :leftOption="leftBindGuider"
                transferMode="bindGuider"
              ></hm-transfer>
            </div>
          </el-form-item> -->
        </div>
        <el-form-item
          label="发放对象属性："
          class="is-required"
          v-show="
            sendWayType === 0 &&
            event === 'registe' &&
            momFeature.length > 0 &&
            babyFeature.length > 0
          "
        >
          <div>
            <div class="mom">
              <div class="attr">孕妈</div>
              <div class="list">
                <!-- <el-checkbox :indeterminate="momIsIndeterminate" v-model="momCheckAll" @change="momHandleCheckAllChange">全选</el-checkbox> -->
                <el-checkbox-group
                  :min="babyAttribute.length <= 0 && 1"
                  v-model="momAttribute"
                  @change="momHandleCheckedChange"
                  class="flex flex-wrap"
                >
                  <el-checkbox
                    v-for="v in momFeature"
                    :label="v"
                    :key="v.featureCode"
                    >{{ v.featureName }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </div>
            <div class="baby">
              <div class="attr">宝宝</div>
              <div class="list">
                <!-- <el-checkbox :indeterminate="babyIsIndeterminate" v-model="babyCheckAll" @change="babyHandleCheckAllChange">全选</el-checkbox> -->
                <el-checkbox-group
                  :min="momAttribute.length <= 0 && 1"
                  v-model="babyAttribute"
                  @change="babyHandleCheckedChange"
                  class="flex flex-wrap"
                >
                  <el-checkbox
                    v-for="v in babyFeature"
                    :label="v"
                    :key="v.featureCode"
                    >{{ v.featureName }}</el-checkbox
                  >
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </el-form-item>
        <div class="btn-wrapper text-center">
          <template v-if="!isEdit">
            <el-button
              size="small"
              type="primary"
              @click="preview"
              v-show="!isPreview || $route.query.type=='edit'"
              :loading="isSaving"
              >预览并发布</el-button
            >
            <el-button
              size="small"
              type="primary"
              @click="publish"
              v-show="isPreview"
              :loading="isPublishing"
              >发布</el-button
            >
          </template>
          <el-button
            size="small"
            type="primary"
            @click="save"
            v-show="!isPreview || $route.query.type=='edit'"
            :loading="isSaving"
            >{{ this.displayMode === "copy" ? "复制" : "保存" }}</el-button
          >
          <el-button size="small" @click="back">返回</el-button>
        </div>
      </el-form>
      <el-dialog :visible.sync="hasInValidPhone" width="30%" title="提示">
        <div>
          <div>
            您有
            <span class="error">{{ errInputResult.length }}</span
            >条数据因手机号错误未导入
          </div>
          <el-table :data="errInputResult" border class="small-table">
            <el-table-column prop="name" label="用户名"></el-table-column>
            <el-table-column prop="mobile" label="手机号"></el-table-column>
          </el-table>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="hasInValidGuider" width="30%" title="提示">
        <div>
          <div>
            您有
            <span class="error">{{ errInputResultGuider.length }}</span
            >条数据因工号错误未导入
          </div>
          <el-table :data="errInputResultGuider" border class="small-table">
            <el-table-column prop="workNum" label="工号"></el-table-column>
          </el-table>
        </div>
      </el-dialog>
       <el-dialog :visible.sync="hasInValidStoreCode" width="30%" title="提示">
        <div>
          <div>
            您有
            <span class="error">{{ errInputResultStoreCode.length }}</span
            >条数据因门店编码错误未导入
          </div>
          <el-table :data="errInputResultStoreCode" border class="small-table">
            <el-table-column prop="shopCode" label="门店编码"></el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import HmTransfer from "@/components/HmCouponTransfer";
import HmDateSelect from "@/components/HmCouponDateSelect";
import HmMicroShopTransfer from "@/components/HmMicroShopTransfer";
import HmGuiderTransfer from "@/components/HmGuiderTransfer";
import { ShopPicker } from "@/components/shop-picker";
import moment from "moment";
import { getLoginUser } from "@/utils/auth";
// import XLSX from "xlsx";
import * as XLSX from 'xlsx/xlsx'
import { getCookie, removeCookie, unique, arrayUnique2 } from "@/utils/utils";
import {  } from "@/utils/utils";

let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {
    HmTransfer,
    HmDateSelect,
    HmMicroShopTransfer,
    HmGuiderTransfer,
    ShopPicker,
  },
  data() {
    const checkSendNum = (rule, val, callback) => {
      if (
        (!this.noGetCouponLimit &&
          this.sendWayType === 0 &&
          (val < 1 || val > 10000)) ||
        (this.sendWayType !== 0 && (val < 1 || val > 10000))
      ) {
        return callback(new Error("数量区间应在1-10000"));
      }
      callback();
    };
    const patternFunc = (rule, val, callback) => {
      if (val < 0) {
        return callback(new Error("金额应该大于或等于0"));
      } else if (parseInt(val) < parseInt(this.ruleForm.amountMin)) {
        return callback(new Error("金额应大于最小金额"));
      }
      callback();
    };
    const patternIdentityTypeFunc = (rule, val, callback) => {
      if (val !== "all") {
        if (this.ruleForm.identityValue.length === 0) {
          return callback(new Error("请选择推荐人限制"));
        }
      }
      callback();
    };
    const overlayRuleModelListFunc = (rule, val, callback) => {
      if (this.ruleForm.overlayType === "ladder") {
        if (this.ruleForm.overlayRuleModelList.length === 0) {
          return callback(new Error("请添加阶梯叠加规则"));
        }
      }

      callback();
    };
    const sendLimitNewFunc = (rule, val, callback) => {
      if (this.ruleForm.overlayType === "cycle") {
        if (
          this.sendLimitNew === "" ||
          this.sendNumNew === "" ||
          this.maxCycleTimes === ""
        ) {
          return callback(new Error("请填写循环叠加规则"));
        } else {
          if (this.sendByGoodsCount) {
            if (
              new Number(this.ruleForm.goodsNumMin) <=
                new Number(this.sendLimitNew) &&
              new Number(this.sendLimitNew) <=
                new Number(this.ruleForm.goodsNumMax)
            ) {
              callback();
            } else {
              return callback(
                new Error(
                  `商品件数不得小于${this.ruleForm.goodsNumMin},不得超过${this.ruleForm.goodsNumMax}`
                )
              );
            }
          } else {
            if (
              new Number(this.ruleForm.amountMin) <=
                new Number(this.sendLimitNew) &&
              new Number(this.sendLimitNew) <=
                new Number(this.ruleForm.amountMax)
            ) {
              callback();
            } else {
              return callback(
                new Error(
                  `金额不得小于${this.ruleForm.amountMin},不得超过${this.ruleForm.amountMax}`
                )
              );
            }
          }
        }
      }
      callback();
    };
    const validateMin = (rule, val, callback) => {
      console.log("goodsNumMax", this.ruleForm.goodsNumMax);
      console.log("goodsNumMin", this.ruleForm.goodsNumMin);
      if(this.ruleForm.goodsNumMax) {
        if(new Number(this.ruleForm.goodsNumMax) < new Number(this.ruleForm.goodsNumMin) ) {
          return callback(new Error('最小商品数量限制不能大于最大商品数量限制'))
        } else {
          return callback()
        }
      }
      return callback()
    }
    const validateMax = (rule, val, callback) => {
      if(this.ruleForm.goodsNumMin) {
        if(new Number(this.ruleForm.goodsNumMax) < new Number(this.ruleForm.goodsNumMin) ) {
          return callback(new Error('最大商品数量限制不能小于最小商品数量限制'))
        } else {
          return callback()
        }
      }
      return callback()
    }
    return {
      ageRuleModelList: [],
      physiologicalPregnantList: [],
      physiologicalBabyList: [],
      iswx: false,
      sendLimitNew: "",
      sendNumNew: "",
      maxCycleTimes: "",
      cardTypeList: [],
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 366 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        },
      },
      couponCode: [],
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationTree", {
                pageNo: 1,
                pageSize: 999,
                loginType: "store",
              })
              .then((res) => {
                res.result.records.forEach((v) => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.orgCode;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryOrganizationListByParent", {
                parentId: data.treeStruct,
              })
              .then((res) => {
                if (res.code === "0" && res.result) {
                  res.result.forEach((v) => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.orgCode;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
      remark: "",
      leftGoodsRules: [],
      sysTag: 0,
      label: "",
      useTarget: "",
      selectedStore: [],
      selectedShops: [],
      isCheckGoods: false,
      couponNameError: "",
      selectedGuider: "",
      sendId: "",
      isActivity: 1,
      bindGuider: false,
      sendByGoodsCount: false,
      noGetCouponLimit: false,
      store: [],
      inputData: [],
      isChecked: false,
      selectedCategory: [],
      designate: false,
      wiriteMode: "",
      displayMode: this.$route.query.type,
      couponSendId: this.$route.query.couponSendId,
      isPreview: false,
      isMultipleTime: true,
      couponType: "",
      ruleValidDate: [],
      subheading: "",
      targetName: "",
      targetPlaceholder: "",
      couponName: "",
      goodsName: "",
      name: "",
      sendTarget: 1,
      sendLimit: 0,
      event: "registe",
      sendTargetLeftName: "所有用户",
      sendWayType: 0,
      sendNum: "",
      amountMax: "",
      amountMin: "",
      activeTab: 0,
      useRange: [],
      brandId: "",
      isSaving: false,
      isPublishing: false,
      catId: "",
      keywords: "",
      options: [
        { name: "满减券类", active: true, value: 0 },
        // { name: "折扣券类", active: false, value: 1 },
        // { name: "运费券类", active: false, value: 2 }
      ],
      leftRules: [],
      // leftGoodsList: [],
      leftCustomerList: [],
      leftStoreList: [],
      leftGuiderList: [],
      leftSendTargetList: [],
      rightRules: [],
      leftBindGuider: [],
      btnList: [
        { name: "满减券类", active: true },
        // { name: "折扣券类", active: false },
        // { name: "运费券类", active: false }
      ],
      defaultProps: {
        children: "children",
        label: "name",
      },
      customer:
        (this.$route.query.customer &&
          JSON.parse(this.$route.query.customer)) ||
        [],
      multipleSelection: [],
      ruleForm: {
        sendLimitNew: "",
        name: "",
        sendNum: "",
        amountMin: "",
        amountMax: "",
        goodsNumMin: "",
        goodsNumMax: "",
        storeOutletIds: [],
        distributionType: "",
        identityType: "",
        identityValue: [],
        overlayRuleModelList: [],
        counted: "",
        overlayType: "no",
        sendCountLimit: "",
        isPlus: 1,
        couponCode: "",
      },
      errInputResult: [],
      errInputResultGuider: [],
      guiderAllList: [],
      selectedGoods: false,
      selectedRules: false,
      selectedTarget: true,
      selectedRuleDate: true,
      selectedDay: true,
      selectedWeek: false,
      selectedDaysList: false,
      selectedTimeList: true,
      bindGuiderCoupon: "",
      momIsIndeterminate: false,
      babyIsIndeterminate: false,
      momCheckAll: true,
      babyCheckAll: true,
      hasInValidPhone: false,
      hasInValidGuider: false,
      errorInputResult: [],
      momAttribute: [],
      babyAttribute: [],
      // 是否显示美素佳儿radio
      isFriso: false,
      rules: {
        name: [
          { required: true, message: "请输入发放名称", trigger: "blur" },
          {
            min: 1,
            max: 15,
            message: "发放名称长度需要 1 到 15 个汉字",
            trigger: "blur",
          },
        ],
        isPlus: {
          required: true,
          message: "请选择发放对象",
          trigger: "blur",
        },
        sendNum: [
          { required: true, message: "请输人领取人数限制", trigger: "blur" },
          { validator: checkSendNum, trigger: "blur" },
        ],
        overlayType: {
          required: true,
          message: "请选择类型",
          trigger: "blur",
        },
        amountMin: [
          { required: true, message: "请输人金额", trigger: "blur" },
          {
            pattern: /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/,
            message: "请输入大于0的数",
            trigger: "blur",
          },
        ],
        goodsNumMin: [
          { required: true, message: "请输人商品数量", trigger: "blur" },
          {
            pattern: /^[1-9]\d*$/,
            message: "请输入大于0的正整数",
            trigger: "blur",
          },
          {
            validator: validateMin, trigger: "blur"
          },
        ],
        goodsNumMax: [
          { required: true, message: "请输人商品数量", trigger: "blur" },
          {
            pattern: /^[1-9]\d*$/,
            message: "请输入大于0的正整数",
            trigger: "blur",
          },
          {
            validator: validateMax, trigger: "blur"
          },
        ],
        amountMax: [
          { required: true, message: "请输人金额", trigger: "blur" },
          { validator: patternFunc, trigger: "blur" },
        ],
        identityType: [
          {
            required: true,
            message: "请选择分类方式",
            trigger: "blur",
          },
          { validator: patternIdentityTypeFunc, trigger: "blur" },
        ],
        overlayRuleModelList: [
          {
            required: true,
            validator: overlayRuleModelListFunc,
          },
        ],
        sendLimitNew: [
          {
            required: true,
            validator: sendLimitNewFunc,
          },
        ],
        distributionType: {
          required: true,
          message: "请选择发券方式",
          trigger: "blur",
        },
        counted: {
          required: true,
          message: "请选择发券计数",
          trigger: "blur",
        },
        sendCountLimit: {
          required: true,
          message: "请选择单次领取限制",
          trigger: "blur",
        },
      },
      initName: "",
      initRemark: "",
      initGoodsNumMin: "",
      initGoodsNumMax: "",
      initRightData: [],
      loginInfoText: "",
      hasInValidStoreCode: false,
      errInputResultStoreCode: []
    };
  },
  created() {
    let username = "";
    let realname = "";
    if(getLoginUser().username){
      username = "账号:" + getLoginUser().username;
    }else{
      username = "";
    }
    if(getLoginUser().realname){
      realname = username? ",用户:" + getLoginUser().realname: "用户:" + getLoginUser().realname;
    }else{
      realname = "";
    }
    this.loginInfoText = username + realname;
    this.isEdit = this.$route.query.type === "edit"
    setTimeout(() => {
      console.log(this.list)
    }, 3000);
    this.$store.dispatch("queryTab", {
      labelName: "",
      pageSize: 9999999,
      type: "back",
    });
    const link = getCookie({ key: "link" });
    this.subheading = link ? link[link.length - 1].name : "增加发放优惠券";
    if (this.customer.length > 0) {
      this.sendWayType = 1;
      this.sendLimit = 1;
    }
    if (this.displayMode === "edit" || this.displayMode === "copy") {
      this.$store.dispatch("querySavedCoupon", {
        couponSendId: this.couponSendId,
      }).then(res=>{
        let result = res.result
        console.log(result)
        // 美素佳儿券代码
        if (result && result.couponSendInfo) {
          this.ruleForm.couponCode = result.couponSendInfo.giftCode
        }
      });
    }
    this.$store
      .dispatch("queryIsFriso", {
        code: "frisonNuState",
      })
      .then((res) => {
        let openStr = res.result.value;
        if(openStr == "open"){
          this.isFriso = true
        }
      });
    this.queryFrisonCouponCode();
  },
  mounted() {
    this.queryPhysiologicalPregnant();
    this.queryPhysiologicalBaby();
    this.queryMemberGroupList();
    this.queryCardTypeList();
    this.customer.forEach((v) => {
      this.$refs.userTable.toggleRowSelection(v);
    });
    const couponSendWritten = getCookie({
      key: "couponSendWritten",
    });

    if (couponSendWritten && this.sendWayType === 1) {
      for (let key in couponSendWritten) {
        if (this.hasOwnProperty(key)) {
          this[key] = couponSendWritten[key];
        }
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = couponSendWritten[key];
        }
      }
      this.noGetCouponLimit = this.ruleForm.sendNum === 9999999;
      this.$refs.ruleTransfer.rightData = couponSendWritten.rightChecked;
      this.$refs.ruleTransfer.rightCheckAll = true;
      this.$refs.ruleTransfer.rightChecked = couponSendWritten.rightChecked;
    }
    // 发放对象未选择导购则置灰
    if (this.sendWayType !== 1) {
      this.$store.commit("queryIsEnable", false);
    } else if (
      this.sendWayType === 1 &&
      this.$refs.guideTransfer.rightChecked.length > 0
    ) {
      this.$store.commit("queryIsEnable", true);
    }

  },
  computed: {
    ...mapGetters(["shopList", "allMemberMgtList"]),
    ...mapState({
      isVaildCouponName: (state) => state.rules.isVaildCouponName,
      isVaildCouponNameBySubmit: (state) =>
        state.rules.isVaildCouponNameBySubmit,
      isVaildCouponNameByPublish: (state) =>
        state.rules.isVaildCouponNameByPublish,
      saveSendRulesCode: (state) => state.rules.saveSendRulesCode,
      allRules: (state) => state.rules.allRules,
      guiderList: (state) => state.system.allEmployee,
      customerList: (state) => state.rules.customerList,
      savedCoupon: (state) => state.rules.savedCoupon,
      editCouponCode: (state) => state.rules.editCouponCode,
      bindCoupon: (state) => state.rules.bindCoupon,
      bindGuiderList: (state) => state.rules.bindGuiderList,
      babyFeature: (state) => state.rules.babyFeature,
      momFeature: (state) => state.rules.momFeature,
      tabList: (state) => state.rules.tabList,
    }),
  },
  watch: {
    isVaildCouponName(val) {
      if (val > 0) {
        // 不可用
        this.couponNameError = "已有该券名,请重新设置";
      }
      this.$store.commit("checkCouponName", "");
    },
    isVaildCouponNameBySubmit(val) {
      if (val > 0) {
        // 不可用
        this.couponNameError = "已有该券名,请重新设置";
        this.$message({
          message: "已有该券名,请重新设置！",
          type: "warning",
        });
      } else if (val === 0) {
        this.sendRequet();
      }
      this.$store.commit("checkCouponNameBySubmit", "");
    },
    isVaildCouponNameByPublish(val) {
      if (val > 0) {
        // 不可用
        this.couponNameError = "已有该券名,请重新设置";
        this.$message({
          message: "已有该券名,请重新设置！",
          type: "warning",
        });
      } else if (val === 0) {
        this.sendPublishRequet();
      }
      this.$store.commit("checkCouponNameByPublish", "");
    },
    momFeature(val) {
      this.momAttribute = val;
    },
    babyFeature(val) {
      this.babyAttribute = val;
    },

    allMemberMgtList(val) {
      const list = val.records || [];
      let isRepeat = false;
      if (list.length > 0) {
        list.forEach((item) => {
          this.customer.push({
            id: item.fansId,
            mobilePhone: item.memberMobile,
            realName: item.memberName,
            memberName: item.memberName,
            defaultCardId: item.defaultCardId,
            cardNo: item.cardNo
          });
        });
        this.customer = arrayUnique2(this.customer, "mobilePhone");
        this.customer.forEach((v, i, arr) => {
          for (let j = i + 1; j < arr.length; j++) {
            if (arr[i].mobilePhone === arr[j].mobilePhone) {
              arr[i].isRepeat = true;
              isRepeat = true;
            }
          }
          setTimeout(() => {
            this.$refs.userTable.toggleRowSelection(v);
          }, 0);
        });
      } else {
        this.$message({
          message: "未查询到用户!",
          type: "warning",
        });
      }
      if (isRepeat) {
        this.$message({
          message: "请注意，有重复手机号用户!",
          type: "warning",
        });
      }
    },
    noGetCouponLimit(val) {
      // const ele = this.$refs.limitCheckBox.$el.nextElementSibling.nextElementSibling.nextElementSibling
      if (val) {
        this.ruleForm.sendNum = 9999999;
        // if (ele) {
        //   ele.style.display = 'none'
        // }
      } else {
        // if (ele) {
        //   ele.style.display = 'block'
        // }
        if (this.sendWayType !== 1) {
          this.ruleForm.sendNum = "";
        } else {
          this.ruleForm.sendNum = 1;
        }
      }
    },
    event(val) {
      const ref = ["offlineCat", "offlineBrand", "offlineGoods", "onlineGoods"];
      ref.forEach((v) => {
        if (this.$refs[v]) {
          this.$refs[v].rightData = [];
        }
      });
      if (this.$refs.hmDateSelect) {
        this.$refs.hmDateSelect.useImmediately = 2;
      }
      if (val === "orderOffline") {
        this.$store.dispatch("queryShopList", { pageNo: 1, pageSize: 99999 });
      } else {
        this.ruleForm.storeOutletIds = [];
      }
    },
    sendLimit(val) {
      if (val === 0) {
        this.selectedTarget = true;
      } else {
        this.selectedTarget = false;
      }
    },
    sendWayType(val) {
      this.noGetCouponLimit = false;
      if (val !== 0) {
        this.event = "";
        if (this.$refs.hmDateSelect) {
          this.$refs.hmDateSelect.useImmediately = 2;
        }
      } else {
        this.event = "registe";
      }
      if (val === 1) {
        this.ruleForm.sendNum = 1;
      } else if (val === 4) {
        this.event = this.savedCoupon.couponSendInfo.event
          ? this.savedCoupon.couponSendInfo.event
          : "exchangeByPoint";
      } else if (val !== 1 && val !== 4) {
        this.ruleForm.sendNum = "";
      }
      if (this.sendNum) {
        this.ruleForm.sendNum = this.sendNum;
      }
      this.bindGuider = false;
      if (val !== 1) {
        this.$store.commit("queryIsEnable", false);
      } else if (
        val === 1 &&
        this.$refs.guideTransfer.rightChecked.length > 0
      ) {
        this.$store.commit("queryIsEnable", true);
      }
    },
    // 回显数据
    savedCoupon(val) {
      const {
        ageRuleList,
        couponSendInfo,
        sendTime,
        ruleList,
        goodsSendList,
        target,
        guider,
        feature
      } = val;
      this.name = couponSendInfo && couponSendInfo.name;
      console.log('couponSendInfocouponSendInfo', couponSendInfo);
      for (let key in couponSendInfo) {
        if (this.hasOwnProperty(key)) {
          this[key] = couponSendInfo[key];
        }
        if (this.ruleForm.hasOwnProperty(key)) {
          console.log('key', key);
          this.ruleForm[key] = couponSendInfo[key];
        }
      }
      this.$set(this.ruleForm, "status", couponSendInfo.status)
      this.initName = couponSendInfo.name
      if (this.ruleForm.overlayType === "cycle") {
        this.sendLimitNew = this.ruleForm.overlayRuleModelList[0].sendLimit;
        this.sendNumNew = this.ruleForm.overlayRuleModelList[0].sendNum;
        this.maxCycleTimes =
          this.ruleForm.overlayRuleModelList[0].maxCycleTimes;
        this.ruleForm.overlayRuleModelList = [];
      }
      this.ruleForm.overlayRuleModelList =
        this.ruleForm.overlayRuleModelList == null
          ? []
          : this.ruleForm.overlayRuleModelList;

      if (
        this.ruleForm.identityType !== "all" &&
        !!this.ruleForm.identityType
      ) {
        this.ruleForm.identityValue =
          couponSendInfo.identityValue && couponSendInfo.identityValue.length
            ? JSON.parse(couponSendInfo.identityValue)
            : "";
      }
      this.ruleForm.storeOutletIds = couponSendInfo.storeOutletId
        ? couponSendInfo.storeOutletId.split(",")
        : [];
      
      // 回显门店选择 - 将 storeOutletIds 转换为 selectedShops 对象数组
      if (this.ruleForm.storeOutletIds && this.ruleForm.storeOutletIds.length > 0) {
        const shopRecords = this.shopList.records || [];
        // 处理 "all" 的情况
        if (this.ruleForm.storeOutletIds.length === 1 && this.ruleForm.storeOutletIds[0] === 'all') {
          this.selectedShops = [...shopRecords];
        } else {
          this.selectedShops = this.ruleForm.storeOutletIds.map(shopId => {
            const shop = shopRecords.find(s => s.shopId === shopId || s.id === shopId);
            return shop || { shopId: shopId, shopName: shopId };
          }).filter(s => s);
        }
      } else {
        this.selectedShops = [];
      }
      
      if (goodsSendList) {
        goodsSendList.forEach((v) => {
          v.attrId = v.goodsSn || v.categoryId || v.brandId || v.valueId;
          v.attrValue =
            v.goodsName || v.categoryName || v.brandName || v.attributeValue;
          v.whitelistState = v.useable === 1 ? "white" : "black";
          if (this.$route.query.type === "edit") {
            v.checked = false;
            v.disabled = true;
          } else {
            v.checked = true;
            v.disabled = false;
          }
        });
        this.initRightData = goodsSendList || [];
        this.$refs.goodsTransfer.rightChecked = goodsSendList || [];
        this.$refs.goodsTransfer.rightData = goodsSendList || [];
      }
      //按商品件数发放回显
      this.sendByGoodsCount =
        Boolean(this.ruleForm.goodsNumMin) &&
        Boolean(this.ruleForm.goodsNumMax);

      if (couponSendInfo.isPlus === 0) {
        this.isActivity = 2;
      }
      const momData = [];
      const babyData = [];
      feature &&
        feature.forEach((v) => {
          this.momAttribute.forEach((item) => {
            if (v.featureCode === item.featureCode) {
              momData.push(item);
            }
          });
          this.babyAttribute.forEach((item) => {
            if (v.featureCode === item.featureCode) {
              babyData.push(item);
            }
          });
        });
      this.momAttribute = momData;
      this.babyAttribute = babyData;
      this.noGetCouponLimit = this.ruleForm.sendNum === 9999999;
      if (ruleList && ruleList.length > 0) {
        this.selectedRules = true;
        ruleList.forEach((v) => {
          v.ruleId = v.couponRuleId;
          switch (v.type) {
            case "0":
              v.type = "满减券";
              break;
            case "1":
              v.type = "折扣券";
              break;
            case "2":
              v.type = "运费券";
              break;
            case "3":
              v.type = "折扣券";
              break;
            case "4":
              v.type = "服务券";
              break;
            case "5":
              v.type = "满量券";
              break;

            default:
              break;
          }
        });
        // 规则列表
        ruleList.forEach((item) => {
          const list = [];
          item.labelMap.forEach((v) => {
            list.push(v.labelName);
          });
          item.ruleId = item.couponRuleId;
          item.labelName = list.toString();
        });

        this.$nextTick(() => {
          this.$refs.ruleTransfer.rightData = ruleList;
          this.$refs.ruleTransfer.rightCheckAll = true;
          this.$refs.ruleTransfer.rightChecked = ruleList;
        });
      }
      if (couponSendInfo.couponSendTarget !== 4) {
        if (val && val.target && val.target.length > 0) {
          this.sendTarget = val.target[0].type;
          this.sendLimit = val.target[0].type;
          const type = target && target[0].type;
          if (type === 0 || type === 1) {
            this.sendTarget = 1;
            this.sendLimit = type;
          } else if (type === 2) {
            this.sendTarget = 2;
          }
          let targetType = "";
          switch (this.sendTarget) {
            // case 1:
            //   targetType = 'userTransfer'
            //   break
            case 2:
              targetType = "guideTransfer";
              break;
            // case 3:
            //   targetType = 'storeTransfer'
            //   break
            default:
              break;
          }
          const newTarget = [];
          target.forEach((v) => {
            newTarget.push({
              id: v.objectId,
              realName: v.objectName,
              mobilePhone: v.objectMobile,
            });
          });
          if (this.sendLimit !== 1 && targetType !== "") {
            this.$refs[targetType].rightData = newTarget;
            this.$refs[targetType].rightCheckAll = true;
            this.$refs[targetType].rightChecked = newTarget;
          } else if (this.sendLimit === 1) {
            this.customer = newTarget;

            this.customer.forEach((v) => {
              setTimeout(() => {
                this.$refs.userTable.toggleRowSelection(v);
              }, 0);
            });
          }
        }
      } else {
        this.sendTarget = 1;
        this.sendLimit = 4;
        const newTarget = [];
        target.forEach((v) => {
          newTarget.push({
            name: v.objectName,
            mobile: v.objectMobile,
          });
        });
        this.inputData = newTarget;
      }
      if (couponSendInfo.sendStartDate !== "") {
        this.$refs.hmDateSelect.ruleDate = [
          moment(
            couponSendInfo.sendStartDate +
              " " +
              couponSendInfo.sendStartTime.split(",")[0]
          ).format("YYYY-MM-DD HH:mm:ss"),
          moment(
            couponSendInfo.sendEndDate +
              " " +
              couponSendInfo.sendEndTime.split(",")[0]
          ).format("YYYY-MM-DD HH:mm:ss"),
        ];
      } else {
        this.$refs.hmDateSelect.ruleDate = [];
      }
      if (this.$refs.hmDateSelect) {
        this.$refs.hmDateSelect.day = couponSendInfo.perday;
        this.$refs.hmDateSelect.ruleTimeStrategyType =
          couponSendInfo.sendTimeStrategyType || 0;
        this.$refs.hmDateSelect.week = couponSendInfo.perweek
          ? couponSendInfo.perweek.split(",")
          : [];
        this.$refs.hmDateSelect.daysList = couponSendInfo.permonth
          ? couponSendInfo.permonth.split(",").map((v) => parseInt(v, 10))
          : [];
      }
      setTimeout(() => {
        if (this.$refs.hmDateSelect) {
          this.$refs.hmDateSelect.useImmediately =
            couponSendInfo.sendTimeStrategyType === 4 ? 2 : 0;
        }
      }, 0);
      if (couponSendInfo.event === "registe") {
        this.event = "registe";
        this.bindGuider = true;
        setTimeout(() => {
          if (this.$refs.bingGuiderTransfer) {
            guider.forEach((v) => {
              v.realname = v.guiderName;
            });
            this.$refs.bingGuiderTransfer.rightData = guider;
            this.$refs.bingGuiderTransfer.rightCheckAll = true;
            this.$refs.bingGuiderTransfer.rightChecked = guider;
          }
        }, 200);

        this.ageRuleModelList = [];
        ageRuleList.forEach((v) => {
          this.ageRuleModelList.push(v.groupId);
        });

        this.$refs.hmDateSelect.timeList = [];
      }
      // 根据不同时间段类型回写不同日期
      if (sendTime && sendTime.length > 0) {
        if (couponSendInfo.sendTimeStrategyType === 4) {
          const time = [
            new Date(
              couponSendInfo.sendStartDate + " " + sendTime[0].sendStartTime
            ),
            new Date(
              couponSendInfo.sendEndDate + " " + sendTime[0].sendEndTime
            ),
          ];
          this.$refs.hmDateSelect.ruleDateAndTime = time;
        } else {
          const timeList = sendTime.map((v) => {
            return {
              start: v.sendStartTime,
              end: v.sendEndTime,
            };
          });
          this.$refs.hmDateSelect.timeList = timeList;
        }
      }
    },
    editCouponCode(val) {
      if (val === 0) {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$router.back(-1);
      }
      this.$store.commit("editCoupon", { code: "" });
      this.isPublishing = false;
      this.isSaving = false;
    },
    guiderList(val) {
      if (val) {
        val.forEach((v) => {
          if (v.employeeId) {
            v.objectId = v.employeeId;
          }
        });
        this.leftSendTargetList = val;
        this.leftBindGuider = val;        
      }
    },
    // customerList (val) {
    //   if (val) {
    //     this.leftSendTargetList = val
    //   }
    // },
    // 监听门店列表变化，处理异步加载后的回显
    shopList: {
      handler(newList) {
        if (newList && newList.records && newList.records.length > 0 && this.ruleForm.storeOutletIds && this.ruleForm.storeOutletIds.length > 0) {
          // 处理 "all" 的情况
          if (this.ruleForm.storeOutletIds.length === 1 && this.ruleForm.storeOutletIds[0] === 'all') {
            this.selectedShops = [...newList.records];
          } else {
            this.selectedShops = this.ruleForm.storeOutletIds.map(shopId => {
              const shop = newList.records.find(s => s.shopId === shopId || s.id === shopId);
              return shop || { shopId: shopId, shopName: shopId };
            }).filter(s => s);
          }
        }
      },
      immediate: true
    },
    // goodsList(val) {
    //   if (val) {
    //     this.leftGoodsList = val
    //     this.leftGoodsList.forEach(v => {
    //       v.name = v.goodsName
    //       v.id = v.goodsId
    //     })
    //   }
    // },
    // offlineGoodsList(val) {
    //   if (val) {
    //     this.leftGoodsList = val
    //     this.leftGoodsList.forEach(v => {
    //       v.name = v.goodsName
    //       v.id = v.goodsId
    //     })
    //   }
    // },
    sendTarget(val) {
      this.leftSendTargetList = [];
      switch (val) {
        case 1:
          this.targetPlaceholder = "用户名/手机号";
          break;
        case 2:
          this.targetPlaceholder = "导购名/手机号/导购工号";
          break;
        case 3:
          this.targetPlaceholder = "门店";
          break;
        default:
          break;
      }
    },
    allRules(val) {
      if (val && val.length > 0) {
        val.forEach((v) => {
          if (v.type === 0) {
            v.type = "满减券";
          } else if (v.type === 1) {
            v.type = "兑换券";
          } else if (v.type === 2) {
            v.type = "运费券";
          } else if (v.type === 3) {
            v.type = "折扣券";
          } else if (v.type === 4) {
            v.type = "服务券";
          } else if (v.type === 5) {
            v.type = "满量券";
          }
        });
      }
      this.leftRules = val;
    },
    saveSendRulesCode(val) {
      if (val === 0) {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$router.back(-1);
      }
      this.$store.state.rules.saveSendRulesCode = "";
      this.isPublishing = false;
      this.isSaving = false;
    },
  },
  methods: {
    handleShopPickerChange(shops) {
      // 更新已选门店ID列表
      this.ruleForm.storeOutletIds = shops.map(s => s.shopId || s.id);
    },
    async queryFrisonCouponCode() {
      const { result } = await this.$store.dispatch(
          "storeDictItems",
          {
            dictCode: "frison_coupon_code",
          }
      );
      this.couponCode = result || [];
    },
    async queryPhysiologicalPregnant() {
      const { result } = await this.$store.dispatch(
        "queryPhysiologicalAroupTypelList",
        {
          groupType: "pregnant",
        }
      );
      this.physiologicalPregnantList = result || [];
    },
    async queryPhysiologicalBaby() {
      const { result } = await this.$store.dispatch(
        "queryPhysiologicalAroupTypelList",
        {
          groupType: "baby",
        }
      );
      this.physiologicalBabyList = result || [];
    },
    goodsNumMinChange() {
      this.empty();
    },
    empty() {
      if (this.ruleForm.overlayType === "ladder") {
        this.ruleForm.overlayRuleModelList = [];
      } else if (this.ruleForm.overlayType === "cycle") {
        this.sendLimitNew = "";
        this.sendNumNew = "";
        this.maxCycleTimes = "";
      }
    },
    sendByGoodsCountChange() {
      this.ruleForm.overlayRuleModelList = [];
      this.sendLimitNew = "";
      this.sendNumNew = "";
      this.maxCycleTimes = "";
    },
    deleteItem(list, i) {
      this.ruleForm[list].splice(i, 1);
    },
    validation() {
      let flag = true;
      if (this.sendByGoodsCount) {
        if (
          this.ruleForm.goodsNumMin == "" ||
          this.ruleForm.goodsNumMax == ""
        ) {
          this.$message({
            message: "请先填写最小和最大商品数量限制",
            type: "warning",
          });
          flag = false;
        }
      } else {
        if (this.ruleForm.amountMin == "" || this.ruleForm.amountMax == "") {
          this.$message({
            message: "请先填写最小和最大订单金额限制",
            type: "warning",
          });
          flag = false;
        }
      }
      return flag;
    },
    addItem(list, sendLimit, sendNum) {
      if (this.validation()) {
        if (sendLimit != "" && sendNum != "") {
          if (this.sendByGoodsCount) {
            if (
              new Number(this.ruleForm.goodsNumMin) <= new Number(sendLimit) &&
              new Number(sendLimit) <= new Number(this.ruleForm.goodsNumMax)
            ) {
              let flag = true;
              this.ruleForm[list].forEach((v) => {
                if (v.sendLimit == sendLimit) {
                  v.sendNum = sendNum;
                  flag = false;
                }
              });
              if (flag) {
                this.ruleForm[list].push({
                  sendLimit,
                  sendNum,
                });
              }

              this.sendLimitNew = "";
              this.sendNumNew = "";
            } else {
              this.$message({
                message: `商品件数不得小于${this.ruleForm.goodsNumMin},不得超过${this.ruleForm.goodsNumMax}`,
                type: "warning",
              });
            }
          } else {
            if (
              new Number(this.ruleForm.amountMin) <= new Number(sendLimit) &&
              new Number(sendLimit) <= new Number(this.ruleForm.amountMax)
            ) {
              let flag = true;
              this.ruleForm[list].forEach((v) => {
                if (v.sendLimit == sendLimit) {
                  v.sendNum = sendNum;
                  flag = false;
                }
              });
              if (flag) {
                this.ruleForm[list].push({
                  sendLimit,
                  sendNum,
                });
              }

              this.sendLimitNew = "";
              this.sendNumNew = "";
            } else {
              this.$message({
                message: `金额不得小于${this.ruleForm.amountMin},不得超过${this.ruleForm.amountMax}`,
                type: "warning",
              });
            }
          }
        }
      }
    },
    isActivityChange(val) {
      if (val === 0) {
        this.ruleForm.sendCountLimit = 1;
      } else {
        this.ruleForm.sendCountLimit = "";
      }
    },
    sendWayTypeChange(val) {
      if (this.event === "wxCardSend") {
        this.iswx = true;
      } else {
        this.iswx = false;
      }
      if (val !== 2 || val !== 5) {
        this.ruleForm.sendCountLimit = "";
      }
      if (val == 4) {
        this.event = "activity";
      }
    },
    eventChange(val) {
      if (val === "wxCardSend") {
        this.leftRules = [];
        this.couponType = 0;
        this.iswx = true;
      } else {
        this.iswx = false;
      }
      this.ruleForm.distributionType = "";
      this.ruleForm.identityType = "";
      this.ruleForm.identityValue = [];
      this.ruleForm.counted = "";
      // if (this.sendWayType !== 1 && this.event == 'frisonNu') {
      //   this.queryFrisonCouponCode();
      // }
    },
    identityTypeChange() {
      this.ruleForm.identityValue = [];
    },
    async queryMemberGroupList() {
      const { result } = await this.$store.dispatch("queryMemberGroupList", {
        pageNo: 1,
        pageSize: 9999,
        enabledState: "yes",
      });

      const { records } = result;

      this.memberGroupList = records.filter((o) => {
        if (o.enabledState === "yes") {
          return o;
        }
      });
    },
    async queryCardTypeList() {
      const { result } = await this.$store.dispatch("queryCardTypeList", {
        pageNo: 1,
        pageSize: 99999,
      });
      this.cardTypeList = result;
    },
    getOfflineBrand() {
      this.$store.dispatch("queryOfflineBrand");
    },
    getOnlineBrand() {
      this.$store.dispatch("queryBrand");
    },
    getOnlineCategory() {
      this.$store.dispatch("queryCategory");
    },
    searchByPhone() {
      this.$store.dispatch("queryAllMemberMgtList", {
        queryType: "memberMobile",
        keyword: this.keywords,
        pageSize: 9999,
        pageNo: 1,
      });
    },
    searchByPhoneOrCardId() {
      this.$store.dispatch("searchByPhoneOrCardId", {
        keyword: this.keywords,
        pageSize: 9999,
        pageNo: 1,
      });
    },
    handleCheckChange() {
      this.isChecked = this.$refs.tree.getCheckedNodes().length > 0;
    },
    switchTab(index) {
      this.btnList.find((v) => {
        v.active = false;
      });
      this.btnList[index].active = true;
      this.activeTab = index;
    },
    preview() {
      this.isPreview = true;
    },
    sendRequet() {
      // 自动发放
      const dealConditions =
        this.event === "orderOffline" ||
        this.event === "orderOnline" ||
        this.event === "recharge";

      this.rules.sendNum[0].required =
        this.sendWayType !== 1 && this.sendWayType !== 4;
      this.rules.amountMin[0].required =
        (!this.sendByGoodsCount && dealConditions) || this.event === "carnival";
      this.rules.amountMax[0].required =
        (!this.sendByGoodsCount && dealConditions) || this.event === "carnival";
      this.rules.goodsNumMin[0].required =
        this.sendByGoodsCount &&
        (this.event === "orderOffline" || this.event === "orderOnline");
      this.rules.goodsNumMax[0].required =
        this.sendByGoodsCount &&
        (this.event === "orderOffline" || this.event === "orderOnline");
      const editParams = this.getParams(
        this.ruleForm.status,
        this.couponSendId
      );
      const normalParams = this.getParams(0);
      let ruleTimeStrategyType = "";
      let ruleDateAndTime = "";
      let useImmediately = "";
      let isSelectedSendDate = true;
      if (this.$refs.hmDateSelect) {
        ruleTimeStrategyType = this.$refs.hmDateSelect.ruleTimeStrategyType;
        ruleDateAndTime = this.$refs.hmDateSelect.ruleDateAndTime;
        useImmediately = this.$refs.hmDateSelect.useImmediately;
        // isSelectedSendDate =
        //   useImmediately === 2 && ruleDateAndTime && ruleDateAndTime.length > 0;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid && this.selectedRules && this.couponNameError === "") {
          // 选择规则
          // 自动发放
          if (
            this.sendWayType === 0 ||
            this.sendWayType === 2 ||
            this.sendWayType === 3 ||
            this.sendWayType === 4 ||
            this.sendWayType === 5
          ) {
            // 选择使用期限
            if (this.event === "registe" && this.bindGuider) {
              if (
                useImmediately === 2 &&
                ruleDateAndTime &&
                ruleDateAndTime.length > 0 &&
                this.$refs.bingGuiderTransfer.rightChecked.length > 0
              ) {
                //  开卡绑定 + 关注公众号 + 升级plus会员 + 选择
                if (this.displayMode === "edit") {
                  this.$store.dispatch("editCoupon", editParams);
                } else {
                  this.$store.dispatch("saveSendRules", normalParams);
                }
                this.isSaving = true;
              } else if (
                useImmediately !== 2 &&
                this.$refs.bingGuiderTransfer.rightChecked.length > 0
              ) {
                if (
                  this.selectedRuleDate &&
                  this.selectedTimeList &&
                  ((ruleTimeStrategyType === 0 && this.selectedDay) ||
                    (ruleTimeStrategyType === 1 && this.selectedWeek) ||
                    (ruleTimeStrategyType === 2 && this.selectedDaysList))
                ) {
                  //  开卡绑定 + 关注公众号 + 升级plus会员 + 选择
                  if (this.displayMode === "edit") {
            
                    this.$store.dispatch("editCoupon", editParams);
                  } else {
                    this.$store.dispatch("saveSendRules", normalParams);
                  }
                  this.isSaving = true;
                }
              }
            } else if (
              (this.event === "orderOffline" || this.event === "orderOnline") &&
              this.sendByGoodsCount
            ) {
              if (this.$refs.ruleTransfer.rightChecked.length) {
                if (this.displayMode === "edit") {
                  let operateMemo = ""
                  if(this.initName != editParams.name) {
                    operateMemo+=`,修改发放名称为${editParams.name}`
                  }
                  if(this.initRemark != editParams.remark) {
                    operateMemo+=`,修改副标题为${editParams.remark}`
                  }
                  if (this.initGoodsNumMin != editParams.goodsNumMin) {
                    operateMemo+=`,修改最小商品数量限制为${editParams.goodsNumMin}`
                  }
                  if( this.initGoodsNumMax != editParams.goodsNumMax) {
                    operateMemo+=`,修改最小商品数量限制为${editParams.goodsNumMax}`
                  }
                  editParams.goodsOfflineList.forEach(v => {
                    if (!this.initRightData.find(item => v.attrId==item.attrId && item.attrValue==v.attrValue)) {
                      operateMemo += `,新增商品名称${v.attrValue}`
                    }
                  })
                  this.$store.dispatch("editCoupon", {...editParams, operateMemo: this.loginInfoText + operateMemo});
                } else {
                  this.$store.dispatch("saveSendRules", normalParams);
                }
                this.isSaving = true;
              } else {
                return false;
              }
            } else {
              if (
                isSelectedSendDate &&
                (this.selectedRuleDate ||
                  (this.selectedTimeList &&
                    ((ruleTimeStrategyType === 0 && this.selectedDay) ||
                      (ruleTimeStrategyType === 1 && this.selectedWeek) ||
                      (ruleTimeStrategyType === 2 && this.selectedDaysList))))
              ) {
                //  开卡绑定 + 关注公众号 + 升级plus会员 + 选择
                if (this.displayMode === "edit") {
                  this.$store.dispatch("editCoupon", editParams);
                } else if (this.displayMode === "copy") {
                  this.$store.dispatch("saveSendRules", editParams);
                } else {
                  this.$store.dispatch("saveSendRules", normalParams);
                }
                this.isSaving = true;
              }
            }
          } else if (this.sendWayType === 1) {
            if (
              (this.sendTarget === 1 &&
                (this.sendLimit === 0 ||
                  (this.sendLimit === 1 && this.multipleSelection.length > 0) ||
                  (this.sendLimit === 4 && this.inputData.length > 0))) ||
              (this.sendTarget === 2 &&
                this.$refs.guideTransfer.rightChecked.length > 0)
            ) {
              if (this.displayMode === "edit") {
                this.$store.dispatch("editCoupon", editParams);
              } else {
                this.$store.dispatch("saveSendRules", normalParams);
              }
              this.isSaving = true;
            }
          }
        } else if (valid && this.couponNameError === "") {
          if (this.sendWayType === 0 && this.event === "recommendedPurchase") {
            // editParams.identityValue = JSON.stringify(editParams.identityValue);
            // normalParams.identityValue = JSON.stringify(
            //   normalParams.identityValue
            // );
            if (this.displayMode === "edit") {
              this.$store.dispatch("editCoupon", editParams);
            } else if (this.displayMode === "copy") {
              this.$store.dispatch("saveSendRules", editParams);
            } else {
              this.$store.dispatch("saveSendRules", normalParams);
            }
          }
        } else {
          this.$message({
            message: "请完善信息",
            type: "warning",
          });
          return false;
        }
      });
      removeCookie({ key: "couponSendWritten" });
    },
    // 保存结果
    save() {
      if (this.initName === this.ruleForm.name) {
        this.$store.dispatch("checkCouponNameBySubmit", "");
      } else {
        this.$store.dispatch("checkCouponNameBySubmit", {
          name: this.ruleForm.name,
        });
      }
    },
    filterGt0OrFixed0(prop) {
      if (prop === "sendNumNew" || prop === "maxCycleTimes") {
        this[prop] = this[prop]
          .replace(".", "")
          .replace("-", "")
          .replace(",", "");
        this[prop] = this[prop].replace(/^(0+)|[^\d]+/g, "");
        this[prop] = this[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
      } else {
        if (this.sendByGoodsCount) {
          this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
          this[prop] = this[prop].replace(/^(0+)|[^\d]+/g, "");
          this[prop] = this[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
        } else {
          // this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
          this[prop] = this[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
          this[prop] = this[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
          this[prop] = this[prop]
            .replace(".", "$#*")
            .replace(/\./g, "")
            .replace("$#*", "."); //去除其他"."
          this[prop] = this[prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
          if (this[prop].indexOf(".") < 0 && this[prop] != "") {
            //首位是0的话去掉
            this[prop] = parseFloat(this[prop]);
          }
        }
      }
    },
    // 过滤大于0且如果是小数保留两位
    filterGt0OrFixed2(prop) {
      // this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this[prop] = this[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this[prop] = this[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this[prop] = this[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this[prop] = this[prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (this[prop].indexOf(".") < 0 && this[prop] != "") {
        //首位是0的话去掉
        this[prop] = parseFloat(this[prop]);
      }
    },
    publish() {
      this.$store.dispatch("checkCouponNameByPublish", {
        name: this.ruleForm.name,
      });
    },
    // 发布结果
    sendPublishRequet() {
      const dealConditions =
        this.event === "orderOffline" ||
        this.event === "orderOnline" ||
        this.event === "recharge";
      this.rules.sendNum[0].required =
        this.sendWayType !== 1 && this.sendWayType !== 4;
      this.rules.amountMin[0].required =
        (!this.sendByGoodsCount && dealConditions) || this.event === "carnival";
      this.rules.amountMax[0].required =
        (!this.sendByGoodsCount && dealConditions) || this.event === "carnival";
      this.rules.goodsNumMin[0].required =
        this.sendByGoodsCount &&
        (this.event === "orderOffline" || this.event === "orderOnline");
      this.rules.goodsNumMax[0].required =
        this.sendByGoodsCount &&
        (this.event === "orderOffline" || this.event === "orderOnline");
      const editParams = this.getParams(1, this.couponSendId);

      const normalParams = this.getParams(1);
      if (
        this.ruleForm.identityType !== "cardType" &&
        this.ruleForm.identityType !== "group"
      ) {
        editParams.identityValue = "";
        normalParams.identityValue = "";
      }
      let ruleTimeStrategyType = "";
      let ruleDateAndTime = "";
      let useImmediately = "";
      let isSelectedSendDate = true;
      if (this.$refs.hmDateSelect) {
        ruleTimeStrategyType = this.$refs.hmDateSelect.ruleTimeStrategyType;
        ruleDateAndTime = this.$refs.hmDateSelect.ruleDateAndTime;
        useImmediately = this.$refs.hmDateSelect.useImmediately;
        // isSelectedSendDate =
        //   useImmediately === 2 && ruleDateAndTime && ruleDateAndTime.length > 0;
      }

      this.$refs.ruleForm.validate((valid) => {
        if (valid && this.selectedRules && this.couponNameError === "") {
          // 选择规则
          // 自动发放
          if (
            this.sendWayType === 0 ||
            this.sendWayType === 2 ||
            this.sendWayType === 3 ||
            this.sendWayType === 4 ||
            this.sendWayType === 5
          ) {
            // 选择使用期限
            if (this.event === "registe" && this.bindGuider) {
              // console.log("bindGuider", this.bindGuider);
              // if (this.$refs.guiderTransfer.rightData.length > 0) {
              //   console.log(normalParams);
              // } else {
              //   this.$message({
              //     message: "请绑定导购!",
              //     type: "warning"
              //   });
              // }
              if (
                useImmediately === 2 &&
                ruleDateAndTime &&
                ruleDateAndTime.length > 0 &&
                this.$refs.bingGuiderTransfer.rightChecked.length > 0
              ) {
                if (this.displayMode === "edit") {
                  this.$store.dispatch("editCoupon", editParams);
                } else if (this.displayMode === "copy") {
                  this.$store.dispatch("saveSendRules", editParams);
                } else {
                  this.$store.dispatch("saveSendRules", normalParams);
                }
                this.isPublishing = true;
              } else if (
                useImmediately !== 2 &&
                this.$refs.bingGuiderTransfer.rightChecked.length > 0
              ) {
                if (
                  this.selectedRuleDate &&
                  this.selectedTimeList &&
                  ((ruleTimeStrategyType === 0 && this.selectedDay) ||
                    (ruleTimeStrategyType === 1 && this.selectedWeek) ||
                    (ruleTimeStrategyType === 2 && this.selectedDaysList))
                ) {
                  //  开卡绑定 + 关注公众号 + 升级plus会员 + 选择
                  if (this.displayMode === "edit") {
                    this.$store.dispatch("editCoupon", editParams);
                  } else if (this.displayMode === "copy") {
                    this.$store.dispatch("saveSendRules", editParams);
                  } else {
                    this.$store.dispatch("saveSendRules", normalParams);
                  }
                  this.isPublishing = true;
                }
              }
            } else if (
              (this.event === "orderOffline" || this.event === "orderOnline") &&
              this.sendByGoodsCount
            ) {
              if (this.$refs.ruleTransfer.rightChecked.length) {
                if (this.displayMode === "edit") {
                  this.$store.dispatch("editCoupon", editParams);
                } else {
                  this.$store.dispatch("saveSendRules", normalParams);
                }
                this.isPublishing = true;
              } else {
                return false;
              }
            } else {
              if (
                isSelectedSendDate &&
                (this.selectedRuleDate ||
                  (this.selectedTimeList &&
                    ((ruleTimeStrategyType === 0 && this.selectedDay) ||
                      (ruleTimeStrategyType === 1 && this.selectedWeek) ||
                      (ruleTimeStrategyType === 2 && this.selectedDaysList))))
              ) {
                //  开卡绑定 + 关注公众号 + 升级plus会员 + 选择
                if (this.displayMode === "edit") {
                  this.$store.dispatch("editCoupon", editParams);
                } else if (this.displayMode === "copy") {
                  this.$store.dispatch("saveSendRules", editParams);
                } else {
                  this.$store.dispatch("saveSendRules", normalParams);
                }
                this.isPublishing = true;
              }
            }
          } else if (this.sendWayType === 1) {
            if (
              (this.sendTarget === 1 &&
                (this.sendLimit === 0 ||
                  (this.sendLimit === 1 && this.multipleSelection.length > 0) ||
                  (this.sendLimit === 4 && this.inputData.length > 0))) ||
              (this.sendTarget === 2 &&
                this.$refs.guideTransfer.rightChecked.length > 0)
            ) {
              if (this.displayMode === "edit") {
                this.$store.dispatch("editCoupon", editParams);
              } else if (this.displayMode === "copy") {
                this.$store.dispatch("saveSendRules", editParams);
              } else {
                this.$store.dispatch("saveSendRules", normalParams);
              }
              this.isPublishing = true;
            }
          }
        } else if (valid && this.couponNameError === "") {
          if (this.sendWayType === 0 && this.event === "recommendedPurchase") {
            // editParams.identityValue = JSON.stringify(editParams.identityValue);
            // normalParams.identityValue = JSON.stringify(
            //   normalParams.identityValue
            // );

            if (this.displayMode === "edit") {
              this.$store.dispatch("editCoupon", editParams);
            } else if (this.displayMode === "copy") {
              this.$store.dispatch("saveSendRules", editParams);
            } else {
              this.$store.dispatch("saveSendRules", normalParams);
            }
          }
        } else {
          return false;
        }
      });
      removeCookie({ key: "couponSendWritten" });
    },
    // 预览点击返回
    back() {
      if (this.isPreview && this.$route.query.type !== "edit") {
        this.isPreview = false;
      } else {
        removeCookie({ key: "couponSendWritten" });
        this.$router.back();
      }
    },
    resetRules() {
      this.couponType = "";
      this.ruleValidDate = [];
      this.couponName = "";
      this.useTarget = "";
      this.sysTag = 0;
    },
    queryRules() {
      const startDate =
        this.ruleValidDate && this.ruleValidDate.length > 0
          ? this.ruleValidDate[0]
          : "";
      const endDate =
        this.ruleValidDate && this.ruleValidDate.length > 0
          ? this.ruleValidDate[1]
          : "";
      this.$store.dispatch("getAllRules", {
        isQueryExpired: 1,
        isSend: 1,
        name: this.couponName,
        startDate,
        endDate,
        pageNo: 1,
        pageSize: 10000,
        status: 1,
        type: this.couponType,
        isPlus: this.useTarget,
        label: this.label,
        sysTag: this.sysTag,
      });
    },
    // resetGoodsList() {
    //   this.catId = ''
    //   this.brandId = ''
    //   this.goodsName = ''
    // },
    // queryGoodsList() {
    //   const catIds = []
    //   this.selectedCategory = this.$refs.tree.getCheckedNodes()
    //   this.selectedCategory.forEach(v => {
    //     catIds.push(v.id)
    //   })
    //   if (this.event === 'orderOnline') {
    //     this.$store.dispatch('queryGoodsList', {
    //       brandId: this.brandId,
    //       catId: this.catId,
    //       goodsName: this.goodsName,
    //       currentPage: 1,
    //       pageSize: 50000
    //     })
    //   } else if (this.event === 'orderOffline') {
    //     const brandIds = this.brandId !== '' ? [this.brandId] : []
    //     this.$store.dispatch('queryOfflineGoodsList', {
    //       brandIds,
    //       catIds,
    //       goodsName: this.goodsName,
    //       currentPage: 1,
    //       pageSize: 50000
    //     })
    //   }
    //   this.leftGoodsList = []
    // },
    hasCheckedGuider(val) {
      this.$refs.guideTransfer.isEnable = val;
    },
    searchTarget() {
      switch (this.sendTarget) {
        case 2:
          this.$store.dispatch("queryEmployee", {
            queryKey: this.targetName,
            loginType: "store",
            orgCode: this.selectedStore[this.selectedStore.length - 1],
            pageSize: 99999,
            pageNo: 1,
          });
          break;
        default:
          break;
      }
    },
    getChecked(selection) {
      this.multipleSelection = selection;
    },
    toQueryStore() {
      this.selectedGuider = "";
      this.$store.dispatch("queryStore");
    },
    toQueryGuider() {
      this.$store.dispatch("queryEmployee", {
        queryKey: this.targetName,
        loginType: "store",
        orgCode: this.selectedStore[this.selectedStore.length - 1],
        pageSize: 99999,
        pageNo: 1,
      });
    },
    async toQueryGuiderAll() {
      const { result } =await this.$store.dispatch("queryEmployee", {
        loginType: "store",
        orgCode: this.selectedStore[this.selectedStore.length - 1],
        pageSize: 99999,
        pageNo: 1,
      });
      this.guiderAllList = result.records || [];
    },
    checkGoods(val) {
      this.isCheckGoods = val;
    },
    getParams(status, couponSendId) {
      const ruleList = this.$refs.ruleTransfer
        ? this.$refs.ruleTransfer.rightChecked || []
        : [];

      this.selectedRules = ruleList.length > 0;
      ruleList.forEach((v) => {
        if (v.ruleId && !v.couponRuleId) {
          v.couponRuleId = v.ruleId;
        }
      });
      let ageRuleModelList = [];

      if (this.event === "registe") {
        let allphysiologicalLsit = this.physiologicalPregnantList.concat(
          this.physiologicalBabyList
        );

        allphysiologicalLsit.forEach((v) => {
          this.ageRuleModelList.forEach((j) => {
            if (v.id === j) {
              ageRuleModelList.push({
                groupId: v.id,
                groupType: v.groupType,
                rangeName: v.rangeName,
                startValue: v.startValue,
                endValue: v.endValue,
              });
            }
          });
        });
      }

      // 发放对象 非指定用户
      let targetList = [];
      if (this.sendTarget) {
        let targetType = "";
        switch (this.sendTarget) {
          // case 1:
          //   targetType = 'userTransfer'
          //   break
          case 2:
            targetType = "guideTransfer";
            break;
          // case 3:
          //   targetType = 'storeTransfer'
          //   break
          default:
            break;
        }
        if (targetType !== "") {
          this.$refs[targetType].rightChecked.forEach((v) => {
            targetList.push({
              id: v.id,
              name: v.name || v.objectName || v.realName || v.realname,
              mobile: v.phone,
            });
          });
        }
      }
      // 发放对象 指定用户
      if (this.sendLimit === 1 && this.sendTarget === 1) {
        // const multipleSelection = [];
        const customer = [];
        // this.multipleSelection.forEach(v => {
        //   multipleSelection.push({
        //     id: v.id,
        //     name: v.realName || v.objectName || v.name,
        //     mobile: v.mobilePhone
        //   });
        // });
        // console.warn("this.customer", this.multipleSelection);
        this.multipleSelection.forEach((v) => {
          customer.push({
            id: v.id,
            name: v.realName || v.objectName || v.name,
            mobile: v.mobilePhone,
          });
        });
        targetList = customer;
      }
      this.selectedTarget = targetList.length > 0;
      switch (this.sendWayType) {
        case 1:
          this.event = "manual";
          break;
        case 2:
          this.event = "fetch";
          break;
        case 3:
          this.event = "exchange";
          break;
        case 5:
          this.event = "self";
          break;
        default:
          break;
      }
      const {
        ruleTimeStrategyType,
        day,
        week,
        daysList,
        timeList,
        ruleDate,
        useImmediately,
        ruleDateAndTime,
      } = this.$refs.hmDateSelect || {};

      // 绑定导购数据
      let guiderList = [];
      if (this.$refs.bingGuiderTransfer) {
        guiderList = this.$refs.bingGuiderTransfer.rightChecked.map(item => {
          if (item.couponSendGuiderId) {
            return item;
          }
          return {
            guiderName: item.realname,
            phone: item.phone,
            guiderId: item.mappingCenterId,
            workNum: item.workNum
          };
        });
      }
      // 是否选择中使用日期
      this.selectedRuleDate = ruleDate !== null;
      // 是否选择使用日月周
      this.selectedDay = day !== "" && day > 0;
      this.selectedWeek = week && week.length > 0;
      this.selectedDaysList = daysList && daysList.length > 0;

      // 是否选择中使用时间
      this.selectedTimeList = timeList && timeList.length > 0;
      let sendStartDate = ruleDate && ruleDate.length > 0 && ruleDate[0];
      let sendEndDate = ruleDate && ruleDate.length > 0 && ruleDate[1];
      if (useImmediately === 0) {
        sendStartDate = moment(sendStartDate).format("YYYY-MM-DD");
        sendEndDate = moment(sendEndDate).format("YYYY-MM-DD");
        sendStartTime = moment(ruleDateAndTime[0]).format("HH:mm:ss");
        sendEndTime = moment(ruleDateAndTime[1]).format("HH:mm:ss");
      }
      // 特定时段 全时段
      let list = this.sendWayType !== 1 && useImmediately !== 2 ? timeList : []; // list存放优惠券的时间
      let sendStartTime = "";
      let sendEndTime = "";

      if (
        useImmediately === 2 &&
        ruleDateAndTime &&
        ruleDateAndTime.length > 0
      ) {
        sendStartDate = moment(ruleDateAndTime[0]).format("YYYY-MM-DD");
        sendEndDate = moment(ruleDateAndTime[1]).format("YYYY-MM-DD");
        sendStartTime = moment(ruleDateAndTime[0]).format("HH:mm:ss");
        sendEndTime = moment(ruleDateAndTime[1]).format("HH:mm:ss");
        list = [
          {
            start: moment(ruleDateAndTime[0]).format("HH:mm:ss"),
            end: moment(ruleDateAndTime[1]).format("HH:mm:ss"),
          },
        ];
      }
      const dealConditions =
        this.event === "orderOffline" ||
        this.event === "orderOnline" ||
        this.event === "recharge";
      const amountMin =
        (!this.sendByGoodsCount && dealConditions) || this.event === "carnival"
          ? this.ruleForm.amountMin
          : "";
      const amountMax =
        (!this.sendByGoodsCount && dealConditions) || this.event === "carnival"
          ? this.ruleForm.amountMax
          : "";
      const goodsNumMin =
        this.sendByGoodsCount &&
        (this.event === "orderOffline" || this.event === "orderOnline")
          ? this.ruleForm.goodsNumMin
          : "";
      const goodsNumMax =
        this.sendByGoodsCount &&
        (this.event === "orderOffline" || this.event === "orderOnline")
          ? this.ruleForm.goodsNumMax
          : "";
      let type = "";
      // 发放所有用户 0 指定用户 1 指定导购 2
      if (this.sendWayType === 1) {
        if (this.sendTarget === 1 && this.sendLimit === 0) {
          type = 0;
        } else if (this.sendTarget === 1 && this.sendLimit === 4) {
          type = 4;
        } else {
          type = this.sendTarget;
        }
      }
      if (daysList) {
        for (let i = 0; i < daysList.length; i++) {
          daysList[i] = daysList[i] < 10 ? `0${daysList[i]}` : daysList[i];
        }
      }
      let sendTimeStrategyType = "";
      if (this.sendWayType !== 1 && useImmediately !== 2) {
        sendTimeStrategyType = ruleTimeStrategyType;
      } else if (useImmediately === 2) {
        sendTimeStrategyType = 4;
      }
      // 客户生理轴
      let featureList = [];
      const mergeList = [...this.momAttribute, ...this.babyAttribute];
      mergeList.forEach((v) => {
        if (this.sendWayType === 0 && this.event === "registe") {
          featureList.push({
            featureCode: v.featureCode,
            paramValue1: v.paramValue1 || "",
            paramValue2: v.paramValue2 || "",
            parentCode: v.parentCode,
          });
        }
      });
      // isActivity为2代表plus会员专属
      const isPlus =
        this.sendWayType == "0" && this.event == "orderOnline"
          ? this.ruleForm.isPlus
          : this.isActivity === 2
          ? 0
          : 1;
      const isGuider = this.isActivity === 3 ? 0 : 1;
      let isActivity = "";
      if (
        (this.sendWayType === 2 || this.sendWayType === 5) &&
        this.isActivity !== 2
      ) {
        isActivity = this.isActivity;
      } else if (
        (this.sendWayType === 2 || this.sendWayType === 5) &&
        (this.isActivity === 2 || this.isActivity === 3)
      ) {
        isActivity = 0;
      } else if (
        this.sendWayType === 4 ||
        this.sendWayType === 0 ||
        this.sendWayType === 1
      ) {
        isActivity = 1;
      }
      let object = [];
      if (
        this.event === "orderOffline" ||
        this.event === "orderOnline" ||
        this.sendWayType === 1
      ) {
        if (this.sendLimit === 4) {
          object = this.inputData;
        } else {
          object = targetList;
        }
      }
      const sendNum =
        (this.sendWayType !== 1 && this.sendWayType !== 4) ||
        (this.sendWayType === 4 && this.event === "activity")
          ? this.noGetCouponLimit
            ? 9999999
            : this.ruleForm.sendNum
          : "";
      if (
        (this.event === "orderOffline" || this.event === "orderOnline") &&
        this.ruleForm.overlayType === "cycle"
      ) {
        this.ruleForm.overlayRuleModelList = [
          {
            sendLimit: this.sendLimitNew,
            sendNum: this.sendNumNew,
            maxCycleTimes: this.maxCycleTimes,
          },
        ];
      }
      let identityValue = this.ruleForm.identityValue
      return {
        ageRuleModelList,
        overlayType: this.ruleForm.overlayType,
        overlayRuleModelList: this.ruleForm.overlayRuleModelList,
        sendCountLimit: this.ruleForm.sendCountLimit,
        distributionType: this.ruleForm.distributionType,
        identityType: this.ruleForm.identityType,
        identityValue:
          identityValue && identityValue.length
            ? JSON.stringify(identityValue)
            : "",
        counted: this.ruleForm.counted,
        giftCode: this.ruleForm.couponCode,
        isGuider,
        goodsOfflineList: this.$refs.goodsTransfer.rightChecked,
        couponSendId,
        status,
        isPlus,
        isActivity,
        type,
        remark: this.remark,
        couponSendTarget: type,
        storeOutletIds: this.ruleForm.storeOutletIds,
        name: this.ruleForm.name, // all
        sendWayType: this.sendWayType, // all
        event: this.event, // all
        sendStartTime: useImmediately === 2 ? sendStartTime : "",
        sendEndTime: useImmediately === 2 ? sendEndTime : "",
        sendNum, // all
        sendStartDate: this.sendWayType !== 1 ? sendStartDate : "", // all
        sendEndDate: this.sendWayType !== 1 ? sendEndDate : "", // all
        ruleList, // all
        sendTimeStrategyType, // 0 1 2
        day:
          this.sendWayType !== 1 &&
          useImmediately !== 2 &&
          this.$refs.hmDateSelect
            ? day
            : "", // 0 1 2
        week:
          this.sendWayType !== 1 &&
          useImmediately !== 2 &&
          this.$refs.hmDateSelect
            ? week.toString()
            : "", // 0 1 2
        daysList:
          this.sendWayType !== 1 &&
          useImmediately !== 2 &&
          this.$refs.hmDateSelect
            ? daysList.toString()
            : "", // 0 1 2
        perday: this.sendWayType !== 1 && useImmediately !== 2 ? day : "", // 0 1 2
        perweek:
          this.sendWayType !== 1 &&
          useImmediately !== 2 &&
          this.$refs.hmDateSelect
            ? week.toString()
            : "", // 0 1 2
        permonth:
          this.sendWayType !== 1 &&
          useImmediately !== 2 &&
          this.$refs.hmDateSelect
            ? daysList.toString()
            : "", // 0 1 2
        list, // 0 1 2
        featureList,
        object,
        amountMin, // 3 4
        amountMax, // 3 4
        goodsNumMin, // 3 4
        goodsNumMax, // 3 4
        guiderList,
      };
    },
    checkCouponNameValid() {
      const name = this.ruleForm.name;
      if (name !== "" && this.initName !== name) {
        this.couponNameError = "";
        this.$store.dispatch("checkCouponName", {
          name,
        });
      }
    },
    resetBindGuider() {
      this.selectedGuider = "";
      this.selectedStore = [];
      this.bindGuiderCoupon = "";
    },
    toQueryBindGuiderCoupon() {
      this.$store.dispatch("queryEmployee", {
        queryKey: this.targetName,
        loginType: "store",
        orgCode: this.selectedStore[this.selectedStore.length - 1],
        pageSize: 99999,
        pageNo: 1,
      });
    },
    async toQueryBindGuider() {
      await this.$store.dispatch("queryEmployee", {
        queryKey: this.targetName,
        loginType: "store",
        orgCode: this.selectedStore[this.selectedStore.length - 1],
        pageSize: 99999,
        pageNo: 1,
      });
    },
    momHandleCheckAllChange(val) {
      this.momAttribute = val ? this.momFeature : [];
      this.momIsIndeterminate = false;
    },
    momHandleCheckedChange(value) {
      let checkedCount = value.length;
      this.momCheckAll = checkedCount === this.momFeature.length;
      this.momIsIndeterminate =
        checkedCount > 0 && checkedCount < this.momFeature.length;
    },
    babyHandleCheckAllChange(val) {
      this.babyAttribute = val ? this.babyFeature : [];
      this.babyIsIndeterminate = false;
    },
    babyHandleCheckedChange(value) {
      let checkedCount = value.length;
      this.babyCheckAll = checkedCount === this.babyFeature.length;
      this.babyIsIndeterminate =
        checkedCount > 0 && checkedCount < this.babyFeature.length;
    },
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        const formatResult = [];
        that.hasInValidPhone = false;
        result.forEach((v) => {
          if (!/^1[0-9]{10}$/.test(v[1]) || !v[1]) {
            that.hasInValidPhone = true;
            that.errInputResult.push({
              name: v[0],
              mobile: v[1],
            });
          } else {
            formatResult.push({
              name: v[0],
              mobile: v[1],
            });
          }
        });
        that.inputData = formatResult;
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    importfGuider(e) {
      this.toQueryGuiderAll().then((res) => {
      const obj = e.target;
      const that = this;
      this.leftSendTargetList = [];
      this.errInputResultGuider = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        let result2 = [];
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
            result.forEach(v=>{
              v.forEach(o=>{
                o = o.toString();
                result2.push(o)
              })
            })
            result2 = unique(result2);
            console.log("去重后的导入数据:",result2);
          }
        });
        const formatResult = [];
        that.hasInValidGuider = false;
        for (let i = 0; i < result2.length; i++) {
          let isExist = false;
          for (let j = 0; j < that.guiderAllList.length; j++) {
            if (result2[i] == that.guiderAllList[j].workNum) {
              formatResult.push(that.guiderAllList[j]); 
              isExist = true;
              break;
            }
          }
          if (!isExist) {
            that.errInputResultGuider.push({
              workNum: result2[i],
            });
            that.hasInValidGuider = true;
          }
        }
        that.leftSendTargetList = formatResult;
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
      })
    },    
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    output() {
      require.ensure([], () => {
        const {
          exportJsonToExcel,
        } = require("../../utils/output/Export2Excel");
        const tHeader = ["用户名", "手机号"];
        const filterVal = ["name", "mobile"];
        const list = [{ name: "", mobile: "", source: "" }];
        const data = this.formatJson(filterVal, list);
        exportJsonToExcel(tHeader, data, "导入用户模板");
      });
    },
    outputGuider() {
      require.ensure([], () => {
        const {
          exportJsonToExcel,
        } = require("../../utils/output/Export2Excel");
        const tHeader = ["工号"];
        const filterVal = ["workNum"];
        const list = [{ workNum: ""}];
        const data = this.formatJson(filterVal, list);
        exportJsonToExcel(tHeader, data, "导入导购模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "商店名称",
          "商店编码"
        ];
        const filterVal = [];
        const data = this.formatJson(filterVal, []);
        exportJsonToExcel(tHeader, data, "门店模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
       // 导入excel
    importfStore(e) {
      const obj = e.target;
      const that = this;
      that.inputData = [];
      that.errInputResultStoreCode = [];
      that.hasInValidStoreCode = false;
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = async function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        const formatResult = [];
        let isRequired = true;
        result.forEach(v => {
          if (!v[0] || !v[1] ) {
            isRequired = false;
          } else {
            isRequired = true
          }
          formatResult.push({
            shopName:v[0],
            shopId:v[1]
          });
        });
        if (isRequired) {
          let arrs = []
          formatResult.forEach(v => {
            arrs.push({shopCode:v.shopId})
          });;
          const { result } = await that.$store.dispatch("importFilterShopCodeList", arrs);
          if(result && result.successShopInfoModelList){
            that.ruleForm.storeOutletIds = result.successShopInfoModelList.map(e=>e.shopId);
          }
          if(result && result.failShopInfoModelList.length){
            that.hasInValidStoreCode = true;
            that.errInputResultStoreCode = result.failShopInfoModelList;
          }
        } else {
          if (!isRequired) {
            that.$message({
              message: "导入失败，请导入完整商店信息！",
              type: "warning"
            });
          }
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
  },
};
</script>
<style lang="scss">
.way-item {
  .el-input {
    width: 80px !important;
    .el-input__inner {
      border: none;
      border-bottom: 1px solid #dcdfe6;
      border-radius: 0;
      padding: 0;
      text-align: center;
    }
  }
}
</style>
<style lang="scss" scoped>
.btn-wrapper {
  margin-top: 2rem;
  height: 33px;
}
.title {
  padding: 0.5rem 0;
  font-size: 14px;
  .star {
    color: #f56c6c;
  }
}

.card-item {
  margin-bottom: 0.5rem;
}
.get-count {
  margin-right: 2rem;
}
.hm-send-container {
  position: relative;
}
.iframe-modal {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  .data-iframe {
    width: 100%;
    height: 100%;
  }
}

.transfer {
  border: 1px solid #e7e8ec;
  height: 485px;
  width: 550px;
  border-radius: 5px;
}
.transfer-header {
  padding: 10px;
  background: #ecf2ff;
  border-radius: 5px 5px 0 0;
}
.transfer-body {
  padding: 10px;
  border-radius: 0 0 5px 5px;
  height: 403px;
  overflow-y: scroll;
}

.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.form-tip {
  font-size: 12px;
  color: #999;
  margin-left: 0.5rem;
}

.no-lineHeight {
  line-height: 0;
}

strong {
  font-style: normal;
  color: #f56c6c;
}
.attr {
  color: #999;
  margin-bottom: 10px;
}

.radio-group-wrapper {
  margin-bottom: 10px;
}

.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}

.input-panel {
  height: 32px;
  margin-bottom: 10px;
  width: 500px;
}

.input-data {
  width: 500px;
}

.scroll-wrapper {
  max-height: 500px;
  overflow-y: scroll;
}

.isRepeat {
  color: #f56c6c;
}

.hm-form-container {
  margin: 0 0 0.5rem;
  padding: 10px;
  border: 1px solid #e7e8ec;
  border-radius: 5px;
}
</style>
